webpackJsonp([1],{

/***/ "/EfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-8 col-xs-12"},[_c('div',{staticClass:"product-item mb-60",staticStyle:{"cursor":"pointer"},on:{"click":_vm.saveCurrentCatPicture}},[_c('div',{staticStyle:{"display":"block","margin-left":"auto","margin-right":"auto"}},[_c('div',{staticClass:"catwrapper",style:({'background-image': _vm.getPictureBG})})]),_vm._v(" "),_c('div',{staticClass:"product-description text-center"},[_c('div',{staticClass:"bottom-center-cat",staticStyle:{"word-wrap":"break-word"}},[_vm._v(_vm._s(_vm.category.Title))])])]),_vm._v(" "),_c('div',{staticClass:"mb-30"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/rm6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isLoading: false
    };
  },

  components: {},
  created: function created() {},

  computed: {},
  methods: {
    navigate: function navigate(item) {
      //this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      //this.$router.go(-1);
    },
    reloadPage: function reloadPage() {
      location.reload(true);
    }
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "1CRx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-24"},[_c('product-details',{attrs:{"product":_vm.product,"isAdding":true}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1lRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDate_vue__ = __webpack_require__("dPQA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df255d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDate_vue__ = __webpack_require__("irNZ");
function injectStyle (ssrContext) {
  __webpack_require__("QKjf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3df255d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df255d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2NE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryItem_vue__ = __webpack_require__("7TeC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365eb045_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryItem_vue__ = __webpack_require__("/EfR");
function injectStyle (ssrContext) {
  __webpack_require__("DMsZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365eb045_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2VJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDelButton_vue__ = __webpack_require__("bkWv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1f5427_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDelButton_vue__ = __webpack_require__("dtLZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDelButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1f5427_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDelButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2sja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_dialog__ = __webpack_require__("7VfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_dialog_dist_vuejs_dialog_min_css__ = __webpack_require__("8cFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_dialog_dist_vuejs_dialog_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_dialog_dist_vuejs_dialog_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import toastr from 'toastr'

 // Import stylesheet









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuejs_dialog___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'appSalonReservation',
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      cartItems: this.$store.state.cart,
      settingsData: {},
      colorApp: '',
      showBasket: true,
      isPaymentPage: false,
      isStoreClosed: false,
      isInFrame: false,
      versionApp: '',
      metaInfo: {
        title: ''
      }
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  created: function created() {

    this.$store.dispatch('allCalendars');

    this.versionApp = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$version;

    document.title = "Reserveer online bij " + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName;
    this.isInFrame = !(self == top);

    if (this.$route.name == "PaymentStatus") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus = true;
    }
    if (this.$route.name == "CustAppoint") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints = true;
    } else if (this.$route.name == "StoreAppoint") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints = true;
    }

    this.loadSettings(); //Niet verplaatsen!

    if (this.$route.name == "PaymentStatus") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus = true;
    } else if (this.$route.name == "CustAppoint") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints = true;
    } else if (this.$route.name == "StoreAppoint") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints = true;
    } else {
      this.$router.push('/'); //Force to root on reload ?
    }

    if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus) this.isPaymentPage = true;
  },

  computed: {
    cartItemsCount: function cartItemsCount() {
      return this.cartItems.length;
    },
    showLoader: function showLoader() {
      return this.$store.state.showLoader;
    },
    getColorApp: function getColorApp() {
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings == undefined) return "";
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    },
    isCustAppoint: function isCustAppoint() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints;
    },
    navRoot: function navRoot() {
      //console.log ("base: " + Vue.$baseUrl);
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl;
    }
  },
  methods: {
    navigate: function navigate(item) {
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      this.$router.go(-1);
    },
    loadSettings: function loadSettings() {

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$errorStartup = false;
      this.settingsData = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings;
      this.colorApp = this.settingsData.ColorApp;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl = '/salonselect';

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName == null) {
        console.log("no store found");
        this.settingsData = { StoreName: 'Geen shop gevonden', StoreAddress: 'op dit domain' };
        this.showBasket = false;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsStoreClosed) {
        this.isStoreClosed = true;
        this.$router.push({ path: '/storeclosed' });
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsHasWelcomeMsg) //Heeft een melding te tonen ?
        {
          var message = {
            title: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName,
            body: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.WelcomeMsg
          };
          var options = {
            html: true,
            okText: 'OK',
            verification: 'Ok'
          };
          this.$dialog.alert(message, options);
        }

      if (this.$route.name == "PaymentStatus") {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus = true;
      }

      var canRoute = true;
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints) canRoute = false;
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus) canRoute = false;

      if (canRoute) {
        this.$router.push({ path: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl });
      }
    }
  }
});

/***/ }),

/***/ "39Jg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"1200px","background-color":"rgb(251, 251, 251)","margin":"0 auto !important","float":"none !important","min-height":"95%","border-radius":"5px","padding-top":"10px","margin-top":"10px","margin-bottom":"10px"},attrs:{"id":"appReservation"}},[_c('header',[_c('loading',{attrs:{"active":_vm.showLoader,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.showLoader=$event}}}),_vm._v(" "),(!_vm.isCustAppoint)?_c('div',{staticClass:"header-main",staticStyle:{"margin-bottom":"15px","margin-top":"15px"}},[_c('div',{staticClass:"container"},[(_vm.isInFrame)?_c('div',{staticClass:"row align-items-center"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.settingsData.IsOnlyExistingCust)?_c('div',{staticClass:"row align-items-center",staticStyle:{"text-align":"center","color":"#ff0000","background-color":"#eeeeee","border-radius":"10px","margin":"5px","padding":"5px","padding-left":"14px","padding-right":"14px"}},[_vm._v("\n                 Online reservatie enkel mogelijk voor bestaande klanten.\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[(!_vm.isPaymentPage)?_c('div',{staticClass:"col-lg-12 col-md-6 col-sm-10"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.navRoot}},[_c('h3',[_vm._v(_vm._s(this.settingsData.StoreName))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(this.settingsData.StoreAddress))])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-6 col-sm-8 ml-auto"},[_c('div',{staticClass:"header-setting-option"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.webshopAddress.length > 5)),expression:"(webshopAddress.length > 5)"}],staticClass:"header-mini-cart"},[_c('a',{attrs:{"href":_vm.webshopAddress,"target":"_blank"}},[_vm._m(1),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","color":"#111111"}},[_vm._v("Webshop")])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"25px","color":"#eeeeee"}},[_vm._v(" | ")]),_vm._v(" "),_c('router-link',{staticClass:"product-link",attrs:{"to":'/myaccount'}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBasket),expression:"showBasket"}],staticClass:"header-mini-cart"},[_c('div',{staticClass:"mini-cart-btn"},[_c('i',{staticClass:"ion-person"})]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","color":"#111111"}},[_vm._v("Account")])])]),_vm._v(" "),_c('router-link',{staticClass:"product-link",attrs:{"to":'/cart'}},[(!_vm.isStoreClosed)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBasket),expression:"showBasket"}],staticClass:"header-mini-cart"},[_c('div',{staticClass:"mini-cart-btn"},[_c('i',{staticClass:"ion-bag"}),_vm._v(" "),_c('span',{staticClass:"cart-notification",style:({ 'background-color': _vm.colorApp})},[_vm._v(_vm._s(this.$store.state.cart.length))])])]):_vm._e()])],1)]),_vm._v(" "),_vm._m(2)])])]):_c('div',{staticClass:"header-main",staticStyle:{"margin-bottom":"15px","margin-top":"15px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-24"},[_c('div',{staticClass:"logo"},[_c('h3',[_vm._v(_vm._s(this.settingsData.StoreName))]),_vm._v("\n                                "+_vm._s(this.settingsData.StoreAddress)+"\n                      ")])])])])]),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/","target":"_blank"}},[_c('i',{staticClass:"ion-info",staticStyle:{"color":"#ff0000","text-decoration":"underline"}},[_vm._v("Open deze reservatie op je mobiel toestel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mini-cart-btn"},[_c('i',{staticClass:"ion-android-globe"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 d-block d-lg-none"},[_c('div',{staticClass:"mobile-menu"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Shw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3tHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['record'],
  data: function data() {
    return {};
  },

  methods: {
    dateSelected: function dateSelected(id) {
      this.record.IsSelected = true;
      this.$emit('dat-select-event', this.record);
    }
  },
  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    },
    buttonStyles: function buttonStyles() {
      return {
        "backgroundColor": this.record.IsSelected ? "#eee" : "#fff",
        "border-radius": '5px',
        "border-width": '1px'
      };
    }
  }
});

/***/ }),

/***/ "4Tgy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"col-6"},[_c('img',{staticClass:"roundedImage",staticStyle:{"margin-bottom":"8px"},attrs:{"src":_vm.getPicture},on:{"click":_vm.selectUser}})]),_vm._v(" "),_c('div',{staticClass:"col-16",staticStyle:{"border-bottom":"1px solid rgb(242,237,237)","margin-bottom":"5px","font-size":"16px"}},[_c('div',{staticClass:"username",on:{"click":_vm.selectUser}},[_vm._v(_vm._s(_vm.user.UserName))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4bWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItemUser__ = __webpack_require__("hn0C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cart_CartItem__ = __webpack_require__("lpJF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cart_CartItemUserLst_vue__ = __webpack_require__("JC6v");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: {
    title: 'Winkelmand'
  },
  data: function data() {
    return {
      cart: this.$store.state.cart,
      storeCustomer: undefined,
      selectedSinleStore: undefined,
      selectedProd: undefined,
      selectedUsers: undefined,
      getProductName: '',
      currentUserBlock: undefined
    };
  },

  components: {
    cartItem: __WEBPACK_IMPORTED_MODULE_2__components_cart_CartItem__["a" /* default */],
    cartItemUser: __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItemUser__["a" /* default */],
    cartItemUserLst: __WEBPACK_IMPORTED_MODULE_3__components_cart_CartItemUserLst_vue__["a" /* default */]
  },
  methods: {
    selectUserEvt: function selectUserEvt(user) {
      document.getElementById("overlayUsers").style.display = "none";
      this.selectedProd.SelectedUserID = user.UserID;
      this.currentUserBlock.setUser(user);
    },
    onselectUserList: function onselectUserList(ctrl, prod, users) {
      console.log(ctrl);
      this.selectedProd = prod;
      this.selectedUsers = users;
      this.getProductName = prod.Title;
      document.getElementById("overlayUsers").style.display = "block";
      this.currentUserBlock = ctrl;
    },
    getSalonAdres: function getSalonAdres(locationname) {
      var arr = locationname.split(",");
      if (arr.length > 1) return arr[1];
      return locationname;
    },
    checkOut: function checkOut() {
      this.$router.push('/DateAppoint');
    },
    getTotalsAdvance: function getTotalsAdvance() {
      var tot = 0;
      for (var c = 0; c < this.cart.length; c++) {
        tot += this.cart[c].PriceAdvance;
      }
      return tot;
    },
    getTotalsAdvancePrice: function getTotalsAdvancePrice() {
      var t = this.getTotalsAdvance();
      return t.toFixed(2);
    },
    navigate: function navigate(item) {
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    this.storeCustomer = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer;
    this.selectedSinleStore = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore;
  },
  created: function created() {},

  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    },
    getUserSelectAllowed: function getUserSelectAllowed() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsHideUsers;
    },
    getHasStoreMsg: function getHasStoreMsg() {
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.MessageBasket == undefined) return false;
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.MessageBasket == null) return false;
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.MessageBasket.length < 20) return false;

      //Check indien leeg (enkel html tags)
      var msg = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.MessageBasket;
      var regex = /(<([^>]+)>)/ig;
      var msgRes = msg.replace(regex, "");
      if (msgRes.length < 3) return false;

      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsBasketMessage;
    },
    getStoreMsg: function getStoreMsg() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.MessageBasket;
    },
    navRoot: function navRoot() {
      //return Vue.$baseUrl;
      if (this.selectedSinleStore != undefined) {
        return '/saloncategories';
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl;
      }
    }
  }
});

/***/ }),

/***/ "4o6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_calendar__ = __webpack_require__("sY/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_calendar_lib_v_calendar_min_css__ = __webpack_require__("xWv6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_calendar_lib_v_calendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_calendar_lib_v_calendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CartDateItem__ = __webpack_require__("fqtn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CartFreePlace__ = __webpack_require__("HJ+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      cart: this.$store.state.cart,
      isHideCal: false,
      weekChangeClicked: true,
      datWeek: '',
      weekRecord: [],
      freePaces: {},
      myDate: new Date(),
      isNoFreePlace: false,
      isShowNextFreeDate: false,
      blockNavToStartOfWeek: false,
      isWeekBack: false,
      dateNextStr: '',
      attrs: [{
        key: 'today',
        dates: new Date()
      }]
    };
  },

  components: {
    //vcalendar: VCalendar,
    dateItem: __WEBPACK_IMPORTED_MODULE_4__CartDateItem__["a" /* default */],
    cartFreePlace: __WEBPACK_IMPORTED_MODULE_5__CartFreePlace__["a" /* default */]
  },
  mounted: function mounted() {

    if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore !== undefined) return;

    this.datWeek = new Date();
    this.myDate = this.datWeek;
    this.blockNavToStartOfWeek = true;
    this.loadWeekCal();
    //this.attrs.highlight.backgroundColor = Vue.$storeSettings.ColorApp;
  },

  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    },
    getUserSelectAllowed: function getUserSelectAllowed() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsHideUsers;
    }
  },
  methods: {
    nextWeek: function nextWeek() {
      this.isWeekBack = false;
      this.blockNavToStartOfWeek = false;
      this.isHideCal = false;
      this.datWeek.setDate(this.datWeek.getDate() + 7);
      this.loadWeekCal();
    },
    prevWeek: function prevWeek() {
      this.isWeekBack = true;
      this.blockNavToStartOfWeek = false;
      this.isHideCal = false;
      this.datWeek.setDate(this.datWeek.getDate() - 7);
      this.loadWeekCal();
    },
    selectDatEvt: function selectDatEvt(evt) {
      this.isWeekBack = false;
      this.isHideCal = false;
      var dtStr = evt.DateStr;
      this.myDate = new Date(evt.Year, evt.Month - 1, evt.Day, 23, 59, 0);
      this.datWeek = this.myDate;

      //console.log (evt);
      if (evt.StatusID == 1) {
        this.isNoFreePlace = true;
        return; //Geen plaats vrij.. geen uren gekend..
      }

      this.hideUnselectedDates(dtStr, false);

      if (this.myDate < new Date()) {
        this.isNoFreePlace = true;
      } else {
        this.isNoFreePlace = false;
        this.loadFreePlaces();
      }
    },
    hideUnselectedDates: function hideUnselectedDates(dtStr, flgReset) {

      if (flgReset) {
        this.weekRecord.Mon.IsSelected = true;
        this.weekRecord.Tue.IsSelected = true;
        this.weekRecord.Wed.IsSelected = true;
        this.weekRecord.Thu.IsSelected = true;
        this.weekRecord.Fri.IsSelected = true;
        this.weekRecord.Sat.IsSelected = true;
        this.weekRecord.Sun.IsSelected = true;
      }

      if (dtStr != this.weekRecord.Mon.DateStr) this.weekRecord.Mon.IsSelected = false;
      if (dtStr != this.weekRecord.Tue.DateStr) this.weekRecord.Tue.IsSelected = false;
      if (dtStr != this.weekRecord.Wed.DateStr) this.weekRecord.Wed.IsSelected = false;
      if (dtStr != this.weekRecord.Thu.DateStr) this.weekRecord.Thu.IsSelected = false;
      if (dtStr != this.weekRecord.Fri.DateStr) this.weekRecord.Fri.IsSelected = false;
      if (dtStr != this.weekRecord.Sat.DateStr) this.weekRecord.Sat.IsSelected = false;
      if (dtStr != this.weekRecord.Sun.DateStr) this.weekRecord.Sun.IsSelected = false;
    },
    showCalendar: function showCalendar() {
      this.isHideCal = !this.isHideCal;
    },
    dayClicked: function dayClicked(day) {
      this.isHideCal = false;
      this.datWeek = day.date;
      this.myDate = day;
      this.blockNavToStartOfWeek = true;
      this.loadWeekCal();
    },
    loadWeekCal: function loadWeekCal() {
      var _this = this;

      var searchRec = { Year: this.datWeek.getFullYear(), Month: this.datWeek.getMonth() + 1, Day: this.datWeek.getDate() };
      __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__["a" /* default */].post('Service/GetDaysWeek', searchRec).then(function (response) {
        _this.weekChangeClicked = false;
        _this.weekRecord = response.data;

        if (!_this.blockNavToStartOfWeek) {
          _this.myDate = new Date(_this.weekRecord.FromYear, _this.weekRecord.FromMonth - 1, _this.weekRecord.FromDay, 23, 59, 0);
          _this.datWeek = _this.myDate;
        }
        _this.blockNavToStartOfWeek = false;

        _this.loadFreePlaces();
        _this.weekChangeClicked = true;
      }).catch(function (error) {
        console.log(error);
        _this.weekChangeClicked = true;
      });
    },
    loadNextFreePlace: function loadNextFreePlace() {
      this.isShowNextFreeDate = true;
      this.hideUnselectedDates(this.dateNextStr, true);
      this.loadFreePlaces();
    },
    loadFreePlaces: function loadFreePlaces() {
      var _this2 = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["r" /* SPINNER_SHOW */]);
      var searchRec = { Year: this.datWeek.getFullYear(), Month: this.datWeek.getMonth() + 1, Day: this.datWeek.getDate(), BasketItems: this.cart, SearchNext: this.isShowNextFreeDate, BackButton: this.isWeekBack };
      console.log(searchRec);

      this.isShowNextFreeDate = false;
      __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__["a" /* default */].post('Basket/GetFreePlaces', searchRec).then(function (response) {
        _this2.freePaces = response.data;
        _this2.isNoFreePlace = false;

        if (_this2.freePaces.Records.length <= 0) {
          _this2.isNoFreePlace = true;
        }
        if (_this2.freePaces.IsNextFreeApp) {
          _this2.dateNextStr = _this2.freePaces.DateStr;

          _this2.myDate = new Date(_this2.freePaces.Year, _this2.freePaces.Month - 1, _this2.freePaces.Day, 23, 59, 0);
          _this2.datWeek = _this2.myDate;

          _this2.datWeek.setDate(_this2.datWeek.getDate() + 1);
          _this2.weekRecord = _this2.freePaces.NextWeekDays;
          _this2.weekChangeClicked = true;
        }
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["s" /* SPINNER_HIDE */]);
      }).catch(function (error) {
        console.log(error);
        _this2.freePaces = [];
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["s" /* SPINNER_HIDE */]);
      });
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_v_calendar___default.a, {
  firstDayOfWeek: 2
});

/***/ }),

/***/ "4zHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-1"}),_vm._v(" "),_c('div',{staticClass:"col-22"},[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),(!this.isError)?_c('div',[_c('div',{staticClass:"row"},[_c('strong',[_vm._v(_vm._s(this.customer.FirstName)+" "+_vm._s(this.customer.LastName))])]),_vm._v(" "),_c('div',{staticClass:"row titleMenuBasket"},[_vm._v(_vm._s(this.customer.Email)+"  "+_vm._s(this.customer.Phone))]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row product-btn"},[_c('a',{staticStyle:{"background-color":"#ff0000","color":"#fff"},on:{"click":_vm.createAppoint}},[_c('i',{staticClass:"ion-bag"}),_vm._v("Maak afspraak voor deze klant")])])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"else":""}},[_vm._v("\n                  "+_vm._s(this.errormsg)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"col-1"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Ya6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ILU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductButton__ = __webpack_require__("HJds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['product'],
  components: {
    'product-button': __WEBPACK_IMPORTED_MODULE_0__ProductButton__["a" /* default */]
  },
  data: function data() {
    return {
      isHideTime: false
    };
  },
  mounted: function mounted() {
    this.isHideTime = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsHideTime;
  },

  methods: {
    navBack: function navBack() {
      this.$router.go(-1);
    }
  },
  computed: {
    hasPackageData: function hasPackageData() {
      if (this.product.Childs == null) {
        return false;
      }
      if (this.product.Childs.length > 0) {
        return true;
      }
      return false;
    },
    totalDurationInfoMsg: function totalDurationInfoMsg() {
      if (this.hasPackageData) return "Totale behandeltijd ongeveer";
      return "Behandeling duurt ongeveer";
    },
    getPicture: function getPicture() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$currCatPicUrl;
    },
    getPrice: function getPrice() {
      if (this.product.Price == "0") {
        return true;
      }
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsHidePrices;
    }
  }
});

/***/ }),

/***/ "7TeC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'category-item',
  props: ['category'],
  data: function data() {
    return {
      urlPicCat: ''
    };
  },
  created: function created() {},

  methods: {
    saveCurrentCatPicture: function saveCurrentCatPicture() {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$currCatName = this.category.Title;
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$currCatPicUrl = this.urlPicCat;
      this.$router.push("/category/" + this.category.CategoryID);
    }
  },
  computed: {
    getPicture: function getPicture() {
      if (this.category == undefined) return;
      this.urlPicCat = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$urlCDN + "Images/" + this.category.PictureUrl;
      return this.urlPicCat;
    },
    getPictureBG: function getPictureBG() {
      //console.log (new Date().getTime())
      if (this.category == undefined) return '';
      this.urlPicCat = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$urlCDN + "Images/" + this.category.PictureUrl;
      return "url('" + this.urlPicCat + "')";
    },
    getPictureBG2: function getPictureBG2() {
      if (this.category == undefined) return '';
      this.urlPicCat = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$urlCDN + "Images/" + this.category.PictureUrl;
      return this.urlPicCat;
    }
  }
});

/***/ }),

/***/ "7giP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppReservation__ = __webpack_require__("tTQw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            isLoading: false,
            hasinstagram: false,
            isPamentPage: false,
            baseColor: '#000000',
            textColor: '#ffffff',
            address1: 'Adresgegevens',
            address2: 'Postcode Stad',
            phone: 'Telefoon',
            mobile: 'Mobiel',
            facebook: 'facebook',
            welcomemsg: '',
            bottomtitle1: '',
            bottomtitle2: '',
            bottommsg1: '',
            bottommsg2: '',
            openhours: '',
            picture: '',
            storename: '',
            captchaimg: '',
            onlinesresclosed: false,
            clientname: '',
            clientphone: '',
            clientmail: '',
            captchacode: '',
            mytokencode: '',
            clientmessage: '',
            disableSendMsg: false,
            flgContactSend: false,
            errormsg: '',
            facebookurl: '',
            instagramurl: ' ',
            titleApp: '',
            versionApp: ''
        };
    },

    components: {
        appReservation: __WEBPACK_IMPORTED_MODULE_3__AppReservation__["a" /* default */]
    },
    created: function created() {

        document.title = "Reserveer online bij " + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.StoreName;

        if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsStoreClosed) {
            document.title = "Welkom bij " + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.StoreName;
        }

        this.versionApp = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$version;
        this.flgContactSend = false;

        this.isPamentPage = false;
        if (this.$route.name == "PaymentStatus") this.isPamentPage = true;
        if (this.$route.name == "CustAppoint") this.isPamentPage = true; //We verbergen ook bij wissen ?

        this.onlinesresclosed = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsStoreClosed;
        this.baseColor = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.ColorApp;
        this.picture = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$urlCDN + '/Images/Minisite/Posworldmain1.jpg';
        this.storename = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.StoreName;
        var jsData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.ShopSiteData);
        this.bottommsg1 = jsData.JsonData.msgfootnote1;
        this.bottommsg2 = jsData.JsonData.msgfootnote2;
        this.bottomtitle1 = jsData.JsonData.msgfoottitle1;
        this.bottomtitle2 = jsData.JsonData.msgfoottitle2;
        this.openhours = jsData.JsonData.openhours;
        this.address1 = jsData.JsonData.address;
        this.address2 = jsData.JsonData.postalcode;
        this.mobile = jsData.JsonData.mobile;
        this.phone = jsData.JsonData.phone;
        this.welcomemsg = jsData.JsonData.msgwelcome;
        this.facebookurl = jsData.JsonData.facebook;
        this.instagramurl = jsData.JsonData.instagram;
        if (jsData.JsonData.urlmainpicture != undefined) {
            if (jsData.JsonData.urlmainpicture.length > 10) {
                this.picture = jsData.JsonData.urlmainpicture;
            }
        }

        if (this.instagramurl != undefined) {
            if (this.instagramurl.length > 10) this.hasinstagram = true;
        }

        if (this.bottomtitle1 === undefined) this.bottomtitle1 = '';
        if (this.bottomtitle2 === undefined) this.bottomtitle2 = '';
        if (this.bottommsg1 === undefined) this.bottommsg1 = '';
        if (this.bottommsg2 === undefined) this.bottommsg2 = '';
        if (this.openhours === undefined) this.openhours = '';

        this.errormsg = '';
        this.loadCaptcha();
    },

    computed: {},
    methods: {
        navigate: function navigate(item) {
            //this.$router.push(item);
        },
        navigateBack: function navigateBack() {
            //this.$router.go(-1);
        },
        scrollToTop: function scrollToTop() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html,body').animate({
                scrollTop: 0
            }, 1000);
        },
        loadCaptcha: function loadCaptcha() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2__api_myhttpapi__["a" /* default */].post('Settings/GetCaptcha').then(function (response) {
                _this.mytokencode = response.data.Token;
                _this.captchaimg = "data:image/jpeg;base64," + response.data.Base64;
            }).catch(function (error) {
                //Hide module
                //this.$store.commit(SPINNER_HIDE);
            });
        },
        sendContact: function sendContact() {
            var _this2 = this;

            this.disableSendMsg = true;
            this.flgContactSend = false;
            var msg = { Token: this.mytokencode, Key: this.captchacode, Name: this.clientname, Email: this.clientmail, Phone: this.clientphone, Message: this.clientmessage };
            __WEBPACK_IMPORTED_MODULE_2__api_myhttpapi__["a" /* default */].post('Settings/SendContact', msg).then(function (response) {
                var result = response.data;
                if (result.ResultCode == 200) {
                    _this2.flgContactSend = true;
                    _this2.errormsg = "Bedankt!";
                } else {
                    _this2.errormsg = result.ErrorMsg;
                    _this2.disableSendMsg = false;
                }
            }).catch(function (error) {
                _this2.disableSendMsg = false;
            });
        }
    }
});

/***/ }),

/***/ "8Im3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-8 col-xs-12"},[_c('div',{staticClass:"product-item mb-10 ml-1 mr-1"},[_c('div',{staticClass:"product-thumb"},[_c('router-link',{staticClass:"product-link",attrs:{"to":'/servicedetail/'+_vm.product.ArticleID}},[_c('img',{attrs:{"src":_vm.getPicture,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"box-label"},[(this.hasPackageData)?[_vm._m(0)]:_vm._e()],2)],1),_vm._v(" "),_c('router-link',{staticClass:"product-link",attrs:{"to":'/servicedetail/'+_vm.product.ArticleID}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"bottom-center-prod",staticStyle:{"word-wrap":"break-word"}},[_vm._v(_vm._s(_vm.product.Title))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"product-link",attrs:{"to":'/servicedetail/'+_vm.product.ArticleID}},[_c('div',{staticClass:"price-box mt-10"},[(!_vm.isHideTime)?_c('div',[_vm._v(_vm._s(_vm.getDuration ()))]):_vm._e(),_vm._v(" "),(!_vm.isHidePrice)?_c('div',[_vm._v(_vm._s(_vm.getProdPrice ()))]):_vm._e()])]),_vm._v(" "),_c('product-button',{attrs:{"product":_vm.product}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-label new"},[_c('span',[_vm._v("PAKKET")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8PfV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleSalonCartDate_vue__ = __webpack_require__("rkUk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b7f3abd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleSalonCartDate_vue__ = __webpack_require__("O/61");
function injectStyle (ssrContext) {
  __webpack_require__("CEwe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleSalonCartDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b7f3abd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleSalonCartDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8QdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetails_vue__ = __webpack_require__("6ILU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5fab09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetails_vue__ = __webpack_require__("nzlO");
function injectStyle (ssrContext) {
  __webpack_require__("pqTy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5fab09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8cFf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9SMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItemLstView_vue__ = __webpack_require__("gl21");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f336ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemLstView_vue__ = __webpack_require__("OYSY");
function injectStyle (ssrContext) {
  __webpack_require__("pEla")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItemLstView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f336ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemLstView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ADjw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop-product-wrap grid"},[_vm._l((_vm.products),function(product){return [_c('product-item',{attrs:{"product":product}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AZDo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B4Rf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12 col-sm-24"},[_c('img',{attrs:{"src":_vm.payImgUrl}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24"},[_c('h2',[_vm._v("Betaalstatus")]),_c('br'),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.paymentStatInfo))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('br'),(_vm.statusPayment === 2)?_c('button',{staticClass:"check-btn sqr-btn"},[_vm._v("Start / Maak nieuwe reservatie")]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12 col-sm-24"},[(_vm.flgShowRetryPayment)?_c('div',[_c('button',{staticClass:"check-btn sqr-btn",on:{"click":function($event){return _vm.retryPament()}}},[_vm._v("Probeer opnieuw")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"height":"40px"}}),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BXiu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CEwe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CUHa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartCheckout_vue__ = __webpack_require__("tAl0");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abf32f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartCheckout_vue__ = __webpack_require__("xTHT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartCheckout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abf32f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartCheckout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "CaqG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DHur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartConfirm_vue__ = __webpack_require__("kCsH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cc2cb8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartConfirm_vue__ = __webpack_require__("egFO");
function injectStyle (ssrContext) {
  __webpack_require__("DiXE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cc2cb8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DMsZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DiXE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_PRODUCTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRODUCT_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PRODUCT_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REMOVE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REMOVE_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLEAR_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ALL_MANUFACTURERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ALL_MANUFACTURERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ALL_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ALL_CATEGORIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ALL_CALENDARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ALL_CALENDARS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SPINNER_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SPINNER_HIDE; });
var ALL_PRODUCTS = 'ALL_PRODUCTS';
var ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS';

var PRODUCT_BY_ID = 'PRODUCT_BY_ID';
var PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS';

var ADD_PRODUCT = 'ADD_PRODUCT';
var ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS';

var UPDATE_PRODUCT = 'UPDATE_PRODUCT';
var UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';

var REMOVE_PRODUCT = 'REMOVE_PRODUCT';
var REMOVE_PRODUCT_SUCCESS = 'REMOVE_PRODUCT_SUCCESS';

var ADD_TO_CART = 'ADD_TO_CART';
var REMOVE_FROM_CART = 'REMOVE_FROM_CART';
var CLEAR_CART = 'CLEAR_CART';

var ALL_MANUFACTURERS = 'ALL_MANUFACTURER';
var ALL_MANUFACTURERS_SUCCESS = 'ALL_MANUFACTURER_SUCCESS';

var ALL_CATEGORIES = 'ALL_CATEGORIES';
var ALL_CATEGORIES_SUCCESS = 'ALL_CATEGORIES_SUCCESS';

var ALL_CALENDARS = 'ALL_CALENDARS';
var ALL_CALENDARS_SUCCESS = 'ALL_CALENDARS_SUCCESS';

var SPINNER_SHOW = 'SPINNER_SHOW';
var SPINNER_HIDE = 'SPINNER_HIDE';

/***/ }),

/***/ "E8Bs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_at_ui__ = __webpack_require__("yweG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_at_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_at_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_at_ui_style__ = __webpack_require__("KF9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_at_ui_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_at_ui_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__("Du/2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // Import CSS



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_at_ui___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {},
  data: function data() {
    return {
      items: []
    };
  },
  created: function created() {

    this.styleControls();
  },

  updated: function updated() {
    this.styleControls();
    document.title = "Reserveer online bij " + __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$storeSettings.StoreName;
  },
  methods: {
    addToCart: function addToCart(product) {

      if (this.hasPackageData(product)) {
        for (var i = 0; i < product.Childs.length; i++) {
          var a = product.Childs[i];
          a.PackageID = product.ArticleID;
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["o" /* ADD_TO_CART */], a);
        }
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["o" /* ADD_TO_CART */], product);
      }

      this.$router.push("/cart");
    },
    hasPackageData: function hasPackageData(product) {
      if (product.Childs == null) {
        return false;
      }
      if (product.Childs.length > 0) {
        return true;
      }
      return false;
    },
    styleControls: function styleControls() {

      var childElements = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(document.querySelectorAll('.at-collapse__header')));
      childElements.map(function (element) {
        element.style.backgroundColor = 'transparent';
        element.style.color = '#fff';
      });

      var childElements2 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(document.querySelectorAll('.at-collapse')));
      childElements2.map(function (element) {
        element.style.backgroundColor = '#fff';
        element.style.borderRadius = '10px';
        element.style.border = '0px';
      });

      var childElements3 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(document.querySelectorAll('.at-collapse__icon')));
      childElements3.map(function (element) {
        element.style.color = '#fff';
      });
    }
  },
  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$storeSettings.ColorApp;
    },
    getPrice: function getPrice() {
      if (__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$storeSettings == undefined) {
        return true;
      }

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$storeSettings.IsHidePrices;
    }
  },
  ready: function ready() {},
  mounted: function mounted() {

    this.styleControls();
  }
});

/***/ }),

/***/ "EFmE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceDetail_vue__ = __webpack_require__("GbkH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_734898f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceDetail_vue__ = __webpack_require__("1CRx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_734898f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F5kq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24"},[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"product-btn",staticStyle:{"color":"#111111"}},[_c('a',{on:{"click":function($event){return _vm.navigateBack();}}},[_c('i',{staticClass:"ion-arrow-left-c",staticStyle:{"color":"#111111"}}),_vm._v("Terug")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24"},[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contact-message pt-20 pt-sm-20"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-24 contact-btn text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mail),expression:"mail"}],attrs:{"name":"email_address","placeholder":"Email *","type":"text"},domProps:{"value":(_vm.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-24 contact-btn text-center"},[_c('div',{staticClass:"product-btn"},[_c('a',{style:({ 'background-color': _vm.getColorApp, color: '#fff'}),on:{"click":_vm.getMyApps}},[_c('i',{staticClass:"ion-bag"}),_vm._v("Afspraken ophalen")])])]),_vm._v(" "),_c('div',{staticClass:"col-24",staticStyle:{"height":"40px"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v("   "),_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.errormsg))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._v("  "),_c('h5',{staticStyle:{"font-weight":"bold"}},[_vm._v("Mijn afspraken")]),_vm._v("\n              Geef hieronder je email adres in en ontvang al je afspraken via mail.\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24",staticStyle:{"height":"40px"}},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fk4A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__ = __webpack_require__("lpJF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cart_CartCheckout_vue__ = __webpack_require__("CUHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: {
    title: 'Mijn account'
  },
  name: 'product-list',
  props: ['products'],
  data: function data() {
    return {
      cart: this.$store.state.cart,
      flgShowDet: false,
      mail: '',
      errormsg: ''
    };
  },

  components: {
    cartItem: __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__["a" /* default */]
  },
  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    },
    getSelectedTime: function getSelectedTime() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime;
    },
    getSelectedTimeInfo: function getSelectedTimeInfo() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime.TimeInfo;
    },
    getSelectedDateInfo: function getSelectedDateInfo() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime.DateInfo;
    }
  },
  mounted: function mounted() {
    this.mail = "";

    if (localStorage.mail) {
      this.mail = localStorage.mail;
    }
  },

  methods: {
    navigate: function navigate(item) {
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      this.navigate("/");
    },
    showDetails: function showDetails() {
      this.flgShowDet = !this.flgShowDet;
    },
    getMyApps: function getMyApps() {
      var _this = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["r" /* SPINNER_SHOW */]);
      localStorage.mail = this.mail;
      this.errormsg = '';

      var cust = { Email: this.mail
        // const appointRec = {Customer: cust }
      };__WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__["a" /* default */].post('Account/GetMyAccount', cust).then(function (response) {
        var result = response.data;
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["s" /* SPINNER_HIDE */]);
        if (result.ResultCode == 0) {

          // this.$store.state.cart = [];
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["q" /* CLEAR_CART */]);
          _this.navigate("/MyAccountSend");
        } else if (result.ResultCode > 0) {
          //alert (result.ErrorMsg);
          _this.errormsg = result.ErrorMsg;
          _this.navigate("/MyAccount");
        }
      }).catch(function (error) {
        console.log(error);
        _this.freePaces = [];
        alert(error);
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["s" /* SPINNER_HIDE */]);
      });
    }
  }
});

/***/ }),

/***/ "G8sS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");





//Posworld API
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$version = 'v6.2.510';
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$isPosworld = false;

//Vue.$urlAPI =  "http://localhost:52616/api/"; 
//Vue.$urlAPI =  "https://posworldfrontoffice.azurewebsites.net/apidata/api/"; 

//  Vue.$urlCDN = "https://posworldshopcdn.azurewebsites.net/";  Staat in main.js !
//  Vue.$urlCDN =  "https://cdn.posworld.be/"; 

//Salonworld API
//Vue.$urlAPI =  "http://localhost:26311/api/";  //Sw
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$urlAPI = "https://onlineresapi.afsprakenboek.be/api/";

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$tokenAPI = localStorage.getItem("usertoken");
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$domain = window.location.hostname;

var myHttpApi = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$urlAPI
});

myHttpApi.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers.common['MyToken'] = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$tokenAPI;
  config.headers.common['MyDomain'] = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$domain;
  return config;
}, function (error) {
  // Do something with request error
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

myHttpApi.interceptors.response.use(function (response) {
  return response;
}, function (error) {

  if (error.response == undefined) {
    //console.log ("api error 1 :" + error);
    //alert (error);
    //router.push('/login');
  } else {
    if (error.response.status === 401) {
      //router.push('/login');
    } else if (error.response.status === 406) {
      //Wordt verder in app opgevangen.. custom melding..
    } else {
        //console.log ("api error 1 :" + error);
        //alert (error);
        //router.push({ path: 'Error' })
        //        router.push({ path: 'Error' })
      }
  }
  __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: 'Error' });
  //throw error;
});

/* harmony default export */ __webpack_exports__["a"] = (myHttpApi);

/***/ }),

/***/ "GWkv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreAppoint_vue__ = __webpack_require__("MuSL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72098826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreAppoint_vue__ = __webpack_require__("4zHy");
function injectStyle (ssrContext) {
  __webpack_require__("CaqG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreAppoint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72098826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreAppoint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GbkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_products_ProductDetails__ = __webpack_require__("8QdX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import ProductCart from '../components/cart/ProductDetCart'

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    navigate: function navigate(item) {
      console.log("nav to :" + item);
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {

      this.$router.go(-1);
    }
  },
  computed: {
    product: function product() {
      var records = this.$store.getters.allCategories;

      var id = this.$route.params['id'];
      for (var i = 0; i < records.length; i++) {
        var cat = records[i];
        if (cat.Services != null) {
          for (var s = 0; s < cat.Services.length; s++) {
            if (cat.Services[s].ArticleID == id) {
              return cat.Services[s];
            }
          }
        }
        if (cat.SubCat != undefined) {
          for (var sc = 0; sc < cat.SubCat.length; sc++) {
            var subcat = cat.SubCat[sc].Services;
            for (var ss = 0; ss < subcat.length; ss++) {
              if (subcat[ss].ArticleID == id) {
                return subcat[ss];
              }
            }
          }
        }
      }
      return this.$store.getters.productById(this.$route.params['id']);
    }
  },
  components: {
    'product-details': __WEBPACK_IMPORTED_MODULE_0__components_products_ProductDetails__["a" /* default */]
    //'product-cart': ProductCart
  }
});

/***/ }),

/***/ "HJ+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartFreePlace_vue__ = __webpack_require__("gdtt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bacc598e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartFreePlace_vue__ = __webpack_require__("yFQu");
function injectStyle (ssrContext) {
  __webpack_require__("Mwb2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartFreePlace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bacc598e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartFreePlace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HJds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductButton_vue__ = __webpack_require__("riLc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139eb274_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductButton_vue__ = __webpack_require__("eOjG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139eb274_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HsYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalonCategories_vue__ = __webpack_require__("Kctr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff7e4eb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalonCategories_vue__ = __webpack_require__("bkBI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalonCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff7e4eb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalonCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__("ukYY");








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  strict: true,
  state: {
    // bought items
    cart: [],
    // ajax loader
    showLoader: false,
    // selected product
    product: {},
    // all products
    products: [],
    // all manufacturers
    manufacturers: [],
    // all categories
    categories: [],
    category: {},

    calendars: [],
    calendar: {}

  },
  // GETTERS
  getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* productGetters */], __WEBPACK_IMPORTED_MODULE_3__getters__["b" /* manufacturerGetters */]),

  actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* productActions */], __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* manufacturerActions */]),

  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* productMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* cartMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* manufacturerMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["d" /* spinnerMutations */])
}));

/***/ }),

/***/ "Ipsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record !== undefined)?_c('div',[_c('div',{staticClass:"col-lg-24 col-md-24 col-sm-24 col-xs-24",on:{"click":_vm.dateSelected}},[_c('span',{staticClass:"roundedCircle",style:(_vm.buttonStyles)},[_vm._v(_vm._s(_vm.record.Day)+"/"+_vm._s(_vm.record.Month))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-24 col-md-24 col-sm-24 col-xs-24",on:{"click":_vm.dateSelected}},[_c('span',{staticClass:"roundedCircleMsg"},[_vm._v(_vm._s(_vm.record.DayName))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IzEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItem_vue__ = __webpack_require__("XAbA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_633f3c9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItem_vue__ = __webpack_require__("8Im3");
function injectStyle (ssrContext) {
  __webpack_require__("UMmr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_633f3c9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J4xf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSingleUser),expression:"!isSingleUser"}],staticClass:"row"},[_c('div',{staticClass:"col-14"},[_vm._v("Voorkeur behandelaar?")]),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('a',{staticStyle:{"color":"#ee0000","text-decoration":"underline"},on:{"click":_vm.selectUser}},[_vm._v(_vm._s(this.selUser.UserName))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-24",staticStyle:{"height":"10px"}},[_vm._v(" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JC6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartItemUserLst_vue__ = __webpack_require__("KfAX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412c144e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartItemUserLst_vue__ = __webpack_require__("J4xf");
function injectStyle (ssrContext) {
  __webpack_require__("aSR9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartItemUserLst_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412c144e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartItemUserLst_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JF0O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductItem_vue__ = __webpack_require__("IzEQ");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product-list',
  props: ['products'],
  components: {
    'product-item': __WEBPACK_IMPORTED_MODULE_0__ProductItem_vue__["a" /* default */]
  },
  mounted: function mounted() {},

  methods: {
    navBack: function navBack() {
      console.log("navigate back");
      this.$router.go(-1);
    }
  }
});

/***/ }),

/***/ "JIyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__("rQVO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cbf192f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__("xYcJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cbf192f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JJXf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JPir":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JWvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"1200px","background-color":"rgb(251, 251, 251)","margin":"0 auto !important","float":"none !important","min-height":"95%","border-radius":"10px","padding-top":"10px","margin-top":"10px","margin-bottom":"10px"},attrs:{"id":"appReservation"}},[_c('header',[_c('loading',{attrs:{"active":_vm.showLoader,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.showLoader=$event}}}),_vm._v(" "),(!_vm.isCustAppoint)?_c('div',{staticClass:"header-main",staticStyle:{"margin-bottom":"15px","margin-top":"15px"}},[_c('div',{staticClass:"container"},[(_vm.isInFrame)?_c('div',{staticClass:"row align-items-center"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.settingsData.IsOnlyExistingCust)?_c('div',{staticClass:"row align-items-center",staticStyle:{"text-align":"center","color":"#ff0000","background-color":"#eeeeee","border-radius":"10px","margin":"5px","padding":"5px","padding-left":"14px","padding-right":"14px"}},[_vm._v("\n                 Online reservatie enkel mogelijk voor bestaande klanten.\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[(!_vm.isPaymentPage)?_c('div',{staticClass:"col-lg-12 col-md-12 col-18"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.navRoot}},[_c('h3',[_vm._v(_vm._s(this.settingsData.StoreName))])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-2 col-2 ml-auto"},[(!_vm.isPaymentPage)?_c('div',{staticClass:"header-setting-option"},[_c('router-link',{staticClass:"product-link",attrs:{"to":'/myaccount'}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBasket),expression:"showBasket"}],staticClass:"header-mini-cart"},[_c('div',{staticClass:"mini-cart-btn"},[_c('i',{staticClass:"ion-person"})]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","color":"#111111"}},[_vm._v("Account")])])]),_vm._v(" "),_c('router-link',{staticClass:"product-link",attrs:{"to":'/cart'}},[(!_vm.isStoreClosed)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBasket),expression:"showBasket"}],staticClass:"header-mini-cart"},[_c('div',{staticClass:"mini-cart-btn"},[_c('i',{staticClass:"ion-bag"}),_vm._v(" "),_c('span',{staticClass:"cart-notification",style:({ 'background-color': _vm.colorApp})},[_vm._v(_vm._s(this.$store.state.cart.length))])])]):_vm._e()])],1):_vm._e()]),_vm._v(" "),_vm._m(1)])])]):_c('div',{staticClass:"header-main",staticStyle:{"margin-bottom":"15px","margin-top":"15px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"logo"},[_c('h3',[_vm._v(_vm._s(this.settingsData.StoreName))]),_vm._v("\n                                "+_vm._s(this.settingsData.StoreAddress)+"\n                      ")])])])])]),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/","target":"_blank"}},[_c('i',{staticClass:"ion-info",staticStyle:{"color":"#ff0000","text-decoration":"underline"}},[_vm._v("Open deze reservatie op je mobiel toestel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 d-block d-lg-none"},[_c('div',{staticClass:"mobile-menu"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KF9i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KYnK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record !== undefined)?_c('div',[(_vm.record.StatusID === 1)?_c('div',{staticClass:"inactivepast"},[_c('div',{staticClass:"col-lg-24 col-md-24 col-sm-24 col-xs-24"},[_c('span',{staticClass:"formatDateDayNr"},[_vm._v(_vm._s(_vm.record.DayNr))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-24 col-md-24 col-sm-24 col-xs-24",on:{"click":_vm.dateSelected}},[_c('span',{staticClass:"formatDateDayName"},[_vm._v(_vm._s(_vm.record.DayName))])])]):_c('div',{style:(_vm.buttonStyles)},[_c('div',{staticClass:"col-lg-24 col-md-24 col-sm-24 col-xs-24",on:{"click":_vm.dateSelected}},[_c('span',{staticClass:"formatDateDayNr"},[_vm._v(_vm._s(_vm.record.DayNr))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-24 col-md-24 col-sm-24 col-xs-24",on:{"click":_vm.dateSelected}},[_c('span',{staticClass:"formatDateDayName"},[_vm._v(_vm._s(_vm.record.DayName))])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kctr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_products_ProductList_vue__ = __webpack_require__("divg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_categories_CategoryList_vue__ = __webpack_require__("j+8l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__ = __webpack_require__("G8sS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    'product-list': __WEBPACK_IMPORTED_MODULE_1__components_products_ProductList_vue__["a" /* default */],
    'category-list': __WEBPACK_IMPORTED_MODULE_2__components_categories_CategoryList_vue__["a" /* default */]
  },
  data: function data() {
    return {
      currentCat: {},
      storeCustomer: undefined,
      isSubCat: false,
      fullPage: false,
      isRoot: false,
      salonname: '',
      salonlocation: ''
    };
  },
  created: function created() {
    document.title = "Reserveer online bij " + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName;
    this.salonname = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore.UserName;
    this.salonlocation = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore.Location;
    console.log(this.salonname);
  },

  methods: {
    navigate: function navigate(item) {
      this.isSubCat = false;
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      this.$router.go(-1);
      this.isSubCat = false;
    }
  },
  computed: {
    subcategories: function subcategories() {
      var cats = this.$store.getters.allCategories;
      var id = this.$route.params['id'];
      if (cats == undefined) {
        return [];
      }
      this.isSubCat = false;

      for (var i = 0; i < cats.length; i++) {
        var cat = cats[i];
        if (cat.CategoryID == id) {
          this.currentCat = cat;
          if (cat.SubCat == undefined) {
            return [];
          }

          this.isSubCat = true;
          return cat.SubCat;
        } else {
          if (cat.SubCat != undefined) {
            for (var s = 0; s < cat.SubCat.length; s++) {
              if (cat.SubCat[s].CategoryID == id) {
                this.currentCat = cat.SubCat[s];
                this.isSubCat = true;
                return cat.SubCat[s].SubCat;
              }
            }
          }
        }
      }

      this.isSubCat = false;
      return this.$store.getters.allCategories;
    },
    products: function products() {
      var cats = this.$store.getters.allCategories;
      var id = this.$route.params['id'];
      if (cats == undefined) {
        return [];
      }

      for (var i = 0; i < cats.length; i++) {
        var cat = cats[i];
        if (cat.CategoryID == id) {
          return cats[i].Services;
        } else {
          if (cat.SubCat != undefined) {
            for (var s = 0; s < cat.SubCat.length; s++) {
              if (cat.SubCat[s].CategoryID == id) {
                return cat.SubCat[s].Services;
              }
            }
          }
        }
      }

      return [];
    }
  },
  watch: {
    '$route': function $route(to, from) {}
  },
  mounted: function mounted() {
    this.isSubCat = false;
    this.storeCustomer = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer;
  }
});

/***/ }),

/***/ "KfAX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CartItemUser__ = __webpack_require__("hn0C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['product'],
  data: function data() {
    return {
      cart: this.$store.state.cart,
      users: [],
      selUser: {},
      flgShowUsers: false,
      isSingleUser: true
    };
  },

  components: {
    CartItemUser: __WEBPACK_IMPORTED_MODULE_0__CartItemUser__["a" /* default */]
  },
  mounted: function mounted() {
    this.selUser = { UserName: '?', UserID: '' };
    this.loadUsers();
  },

  computed: {},
  methods: {
    selectUser: function selectUser() {

      this.$emit('user-select-forprod', this, this.product, this.users);
    },
    setUser: function setUser(user) {
      this.selUser = user;
    },
    loadUsers: function loadUsers() {
      var _this = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["r" /* SPINNER_SHOW */]);
      this.selUser = { UserName: '?', UserID: '' };
      this.isSingleUser = true;
      var searchRec = { Search: this.product.ArticleID, Extra: "" };
      __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */].post('Service/ServiceUsers', searchRec).then(function (response) {
        _this.users = response.data;
        if (_this.users.length > 1) {
          _this.isSingleUser = false;
          _this.selUser = _this.users[0];
          if (_this.product.SelectedUserID != undefined) {
            //console.log ("Selected user for this :" + this.product.SelectedUserID);
            for (var u = 0; u < _this.users.length; u++) {
              if (_this.users[u].UserID == _this.product.SelectedUserID) {
                _this.selUser = _this.users[u];
                break;
              }
            }
          }
        }
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* SPINNER_HIDE */]);
      }).catch(function (error) {
        console.log(error);
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* SPINNER_HIDE */]);
      });
    },
    scrollTo: function scrollTo(element, scrollPixels, duration) {
      var scrollPos = element.scrollLeft;
      // Condition to check if scrolling is required
      if (!((scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0))) {
        var _scroll = function _scroll(timestamp) {
          //Calculate the timeelapsed
          var timeElapsed = timestamp - startTime;
          //Calculate progress 
          var progress = Math.min(timeElapsed / duration, 1);
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress;
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(_scroll);
          } else {
            return;
          }
        };
        //Call requestAnimationFrame on scroll function first time


        // Get the start timestamp
        var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

        window.requestAnimationFrame(_scroll);
      }
    },
    swipeLeft: function swipeLeft() {
      var content = this.$refs.contentUser;
      this.scrollTo(content, -300, 800);
    },
    swipeRight: function swipeRight() {
      var content = this.$refs.contentUser;
      this.scrollTo(content, 300, 800);
    }
  }
});

/***/ }),

/***/ "LkKF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['record'],
  data: function data() {
    return {};
  },

  methods: {
    dateSelected: function dateSelected(id) {
      this.record.IsSelected = true;
      this.$emit('dat-select-event', this.record);
    }
  },
  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    },
    buttonStyles: function buttonStyles() {
      return {
        backgroundColor: this.record.IsSelected ? __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp : "#ddd"
      };
    }
  }
});

/***/ }),

/***/ "Lmdv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MuCY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MuSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      errormsg: '',
      isError: false,
      customer: {},
      isShowNewApp: false,
      id: this.$route.params['id']
    };
  },
  mounted: function mounted() {
    this.loadMyCustomerStore();
  },

  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    }
  },
  methods: {
    createAppoint: function createAppoint() {
      this.$router.push('/');
    },
    loadMyCustomerStore: function loadMyCustomerStore() {
      var _this = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["r" /* SPINNER_SHOW */]);
      this.errormsg = "";
      this.customer = {};
      this.isError = false;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer = undefined;
      var searchRec = { Token: this.id };
      __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */].post('Account/GetStoreCustomer', searchRec).then(function (response) {
        if (response.data.ResultCode == 0) {
          _this.customer = response.data;
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer = response.data;
        } else {
          _this.isError = true;
          _this.customer = {};
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer = undefined;
          _this.errormsg = response.data.ErrorMsg;
        }
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* SPINNER_HIDE */]);
      }).catch(function (error) {
        _this.isError = true;
        _this.customer = {};
        _this.errormsg = error;
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer = undefined;
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* SPINNER_HIDE */]);
      });
    }
  }
});

/***/ }),

/***/ "Mvau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'background-color': _vm.baseColor}),attrs:{"id":"app"}},[_c('main',{staticStyle:{"background-color":"#ffffff"},attrs:{"id":"start"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row pt-30"},[_c('div',{staticClass:"col-lg-24 col-md-24 col-sm-24"},[_c('div',{staticClass:"footer-widget text-center"},[_c('div',{staticClass:"product-btn"},[_c('a',{staticStyle:{"color":"#fff","background-color":"#000"},on:{"click":function($event){return _vm.reloadPage()}}},[_c('i',{staticClass:"ion-bag"}),_vm._v("Probeer opnieuw")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center pt-20 pb-20"},[_c('h1',{staticStyle:{"color":"#000000"}},[_vm._v("Fout bij inladen")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mwb2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_meta__ = __webpack_require__("f3bp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AppReservation__ = __webpack_require__("tTQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AppWebsiteV10__ = __webpack_require__("jlnT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AppSalonReservation__ = __webpack_require__("loOH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AppError__ = __webpack_require__("mPQP");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

//import VeeValidate from 'vee-validate';










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$urlCDN = "https://posworldshopcdn.azurewebsites.net/";
//Vue.$urlCDN =  "http://192.168.0.127:16069/"; 

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$currCatPicUrl = '';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$currCatName = '', __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName = 'Posworld';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl = '/'; //Lijst of blokken
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$errorStartup = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer = undefined;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$errorLoading = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore = undefined;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_meta__["a" /* default */], {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

if (!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPosworld) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName = 'Saloworld';

/* eslint-disable no-new */

var isInFrame = !(self == top);
if (isInFrame) document.body.style.backgroundColor = "#ffffff";

//Vue.$store.commit(SPINNER_SHOW);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$errorStartup = false;
__WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__["a" /* default */].post('Settings/GetSettings').then(function (response) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings = response.data;

  var layout = 0;
  if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ShopSiteData != null) {
    var jsdata = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ShopSiteData);
    layout = jsdata.KindLayout;
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind = layout;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind = layout;
  }

  execLayout01(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind);
  execLayout10_11(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind);
  execLayout20(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind);
}).catch(function (error) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$errorLoading = true;
  execLayoutErr();
});

function execLayoutErr() {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    template: '<AppError/>',
    components: { AppError: __WEBPACK_IMPORTED_MODULE_8__AppError__["a" /* default */] }
  });
}

function execLayout01(layout) {
  if (layout > 9) return;
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    template: '<AppReservation/>',
    components: { AppReservation: __WEBPACK_IMPORTED_MODULE_5__AppReservation__["a" /* default */] }
  });
}

function execLayout10_11(layout) {
  if (layout != 10 && layout != 11) return;
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    template: '<AppWebsite10/>',
    components: { AppWebsite10: __WEBPACK_IMPORTED_MODULE_6__AppWebsiteV10__["a" /* default */] }
  });
}

function execLayout20(layout) {
  if (layout != 20) return;
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    template: '<AppSalonReservation/>',
    components: { AppSalonReservation: __WEBPACK_IMPORTED_MODULE_7__AppSalonReservation__["a" /* default */] }
  });
}

/***/ }),

/***/ "NkVp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoriesList_vue__ = __webpack_require__("E8Bs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e0a3aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoriesList_vue__ = __webpack_require__("q+kS");
function injectStyle (ssrContext) {
  __webpack_require__("BXiu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoriesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e0a3aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoriesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O/61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slide"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.weekChangeClicked),expression:"weekChangeClicked"}],staticClass:"row",staticStyle:{"margin-top":"10px"}},[_vm._l((_vm.openDays),function(item){return [_c('div',{staticStyle:{"width":"20%"}},[_c('date-item',{attrs:{"record":item},on:{"dat-select-event":_vm.selectDatEvt}})],1)]})],2)]),_vm._v(" "),(_vm.isHideCal)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"col-12"},[_c('v-calendar',{attrs:{"attributes":_vm.attrs,"min-date":new Date(),"mode":"single"},on:{"dayclick":_vm.dayClicked},model:{value:(_vm.myDate),callback:function ($$v) {_vm.myDate=$$v},expression:"myDate"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.freePaces.NextFreePlaceMsg))])]),_vm._v(" "),_c('div',{staticClass:"col-24"},[(this.openDays.length === 5)?_c('div',{staticClass:"product-btn",staticStyle:{"text-align":"center"}},[_c('a',{staticStyle:{"color":"#fff"},style:({ 'background-color': _vm.getColorApp}),on:{"click":_vm.loadNextFreePlace}},[_c('i',{staticClass:"ion-calendar"}),_vm._v("Volgende datums tonen")])]):_vm._e()])]),_vm._v(" "),(!_vm.isHideCal)?_c('div',{staticClass:"row"},[(!_vm.isNoFreePlace)?_c('div',{staticClass:"col-24"},[_c('cart-free-place',{attrs:{"record":_vm.freePaces}})],1):_c('div',{staticClass:"col-24"},[_c('br'),_vm._v(" "),_c('h5',[_vm._v("Geen tijden beschikbaar op "+_vm._s(this.freePaces.DateInfo))])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OYSY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-24",staticStyle:{"background-color":"#fefefe","margin-top":"7px","padding-top":"7px","min-height":"69px","border-bottom":"1px solid #ccc","margin-bottom":"15px","height":"100%"}},[_c('div',[_c('div',{staticClass:"product-thumbx",staticStyle:{"float":"left","width":"15%"}},[_c('img',{staticStyle:{"max-height":"65px","border-radius":"10px"},attrs:{"src":_vm.getPicture,"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","width":"60%","word-wrap":"break-word","font-weight":"600","margin-left":"5px"}},[_vm._v("\n        "+_vm._s(_vm.product.Title)),_c('br'),_c('span',{staticStyle:{"font-weight":"400"}},[_vm._v(_vm._s(_vm.getDuration ())+" "+_vm._s(_vm.getProdPrice ()))]),_vm._v(" "),(this.hasPackageData)?[_c('br'),_c('span',{staticStyle:{"font-size":"10px"}},[_vm._v(_vm._s(_vm.getPackageData ()))])]:_vm._e(),_vm._v(" "),(_vm.product.Detail.length > 3)?_c('span',[_c('br'),_c('span',{staticStyle:{"font-weight":"100","font-size":"smaller"},domProps:{"innerHTML":_vm._s(_vm.product.Detail)}})]):_vm._e()],2),_vm._v(" "),_c('div',{staticStyle:{"float":"right","width":"15%"}},[_c('product-button',{staticStyle:{"float":"right","background-color":"#fff"},attrs:{"product":_vm.product}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OnzC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P4F5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QKjf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QveT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.storeCustomer != undefined)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v("Afspraak opmaken voor "),_c('strong',[_vm._v(_vm._s(this.storeCustomer.FirstName)+"  "+_vm._s(this.storeCustomer.LastName))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._v("Kies een salon\n  "),_vm._l((_vm.getCalendars),function(item){return [_c('div',{staticClass:"col-xs-24",staticStyle:{"background-color":"rgb(250, 248, 248)","margin-top":"7px","padding-top":"7px","min-height":"69px","margin-bottom":"10px","height":"100%","border-radius":"10px"}},[_c('div',{staticStyle:{"float":"left","word-wrap":"break-word","font-weight":"600","margin-left":"5px"}},[_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(item.UserName))]),_vm._v(" "),[_c('br'),_c('span',{staticStyle:{"font-size":"12px","font-weight":"400"}},[_vm._v(_vm._s(_vm.getSalonAdres (item.Location)))])]],2),_vm._v(" "),_c('div',{staticStyle:{"float":"right","width":"50px","margin-right":"10px"}},[_c('div',{staticClass:"product-btn",on:{"click":function($event){_vm.navigate (item)}}},[_vm._m(0,true)])])])]})],2),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('i'),_vm._v(">")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24",staticStyle:{"color":"#696969","text-align":"center"}},[_c('a',{staticStyle:{"color":"#696969","font-size":"small"},attrs:{"target":"_blank","href":"https://www.posworld.be"}},[_vm._v("Powered by Posworld")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5IS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__ = __webpack_require__("lpJF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product-list',
  props: ['products'],
  data: function data() {
    return {
      selTime: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime,
      cart: this.$store.state.cart,
      flgShowDet: false,
      selectedSinleStore: undefined
    };
  },

  components: {
    cartItem: __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__["a" /* default */]
  },
  mounted: function mounted() {
    this.selectedSinleStore = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore;
  },

  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    }
  },
  methods: {
    getSalonAdres: function getSalonAdres(locationname) {
      var arr = locationname.split(",");
      if (arr.length > 1) return arr[1];
      return locationname;
    },
    navigate: function navigate(item) {
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      this.$router.go(-1);
    },
    resetAppoint: function resetAppoint() {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime = {};
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer = undefined;
      this.navigate('/');
    }
  }
});

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SgUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"product-btn col-24",staticStyle:{"text-align":"center"}},[_c('br'),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Online reservatie is tijdelijk gesloten."),_c('br'),_vm._v("Probeer het later nog eens aub.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SqJY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TfQs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UMmr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return manufacturerGetters; });
var productGetters = {
  // All products
  allProducts: function allProducts(state, getters) {
    return state.products;
  },
  // Get Product by ID
  productById: function productById(state, getters) {
    return function (id) {
      if (getters.allProducts.length > 0) {
        return getters.allProducts.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.product;
      }
    };
  },
  allCategories: function allCategories(state, getters) {
    return state.categories;
  },
  usersProductById: function usersProductById(state, getters) {
    return function (id) {
      return state.usersProductById(id);
    };
  },
  allCalendars: function allCalendars(state, getters) {
    return state.calendars;
  }
};

var manufacturerGetters = {
  // All manufacturers
  allManufacturers: function allManufacturers(state) {
    return state.manufacturers;
  }
};

/***/ }),

/***/ "UzRZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorLoading_vue__ = __webpack_require__("YoDM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ecf434_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorLoading_vue__ = __webpack_require__("f84z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorLoading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ecf434_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorLoading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V6LE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VPq6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XAbA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductButton_vue__ = __webpack_require__("HJds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product-item',
  props: ['product'],
  components: {
    'product-button': __WEBPACK_IMPORTED_MODULE_0__ProductButton_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlPicCat: '',
      isHideTime: false,
      isHidePrice: false
    };
  },
  mounted: function mounted() {
    this.urlPicCat = '';
    this.urlPicCat = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$currCatPicUrl;

    if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings != undefined) {
      this.isHideTime = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsHideTime;
      this.isHidePrice = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsHidePrice;
    }

    // console.log ("loading pic 1:" + Vue.$currCatPicUrl)
  },
  activated: function activated() {
    //console.log ("loading pic :" + Vue.$currCatPicUrl)
    this.urlPicCat = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$currCatPicUrl;
  },

  methods: {
    getDuration: function getDuration() {
      if (this.isHideTime) return " ";
      if (this.product.IntDuration <= 0) return "  ";
      return this.product.IntDuration + " min.";
    },
    getProdPrice: function getProdPrice() {
      if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsHidePrices) return " ";
      if (parseFloat(this.product.Price) == 0) return " op aanvraag ";
      var p = parseFloat(this.product.Price);
      return "€" + p.toFixed(2);
    }
  },
  computed: {
    hasPackageData: function hasPackageData() {
      this.urlPicCat = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$currCatPicUrl;
      if (this.product.Childs == null) {
        return false;
      }
      if (this.product.Childs.length > 0) {
        return true;
      }
      return false;
    },
    getPicture: function getPicture() {
      this.urlPicCat = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$currCatPicUrl;
      return this.urlPicCat; //Vue.$currCatPicUrl;
    }
  }
});

/***/ }),

/***/ "XZtv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"max-width":"450px","margin":"auto"}},[_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"width":"14%","text-align":"center"},on:{"click":_vm.prevWeek}},[_c('i',{staticClass:"ion-arrow-left-b"})]),_vm._v(" "),_c('div',{staticClass:"titleDate",staticStyle:{"width":"72%"},on:{"click":_vm.showCalendar}},[_vm._v(_vm._s(this.weekRecord.Descr)+" "),_c('i',{staticClass:"ion-calendar"})]),_vm._v(" "),_c('div',{staticStyle:{"width":"14%","text-align":"center"},on:{"click":_vm.nextWeek}},[_c('i',{staticClass:"ion-arrow-right-b"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.weekChangeClicked),expression:"weekChangeClicked"}],staticClass:"row",staticStyle:{"margin-top":"10px","margin-left":"15px"}},[_c('div',{staticStyle:{"width":"14%"}},[_c('date-item',{staticClass:"calenderitem",attrs:{"record":this.weekRecord.Mon},on:{"dat-select-event":_vm.selectDatEvt}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"14%"}},[_c('date-item',{staticClass:"calenderitem",attrs:{"record":this.weekRecord.Tue},on:{"dat-select-event":_vm.selectDatEvt}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"14%"}},[_c('date-item',{staticClass:"calenderitem",attrs:{"record":this.weekRecord.Wed},on:{"dat-select-event":_vm.selectDatEvt}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"14%"}},[_c('date-item',{staticClass:"calenderitem",attrs:{"record":this.weekRecord.Thu},on:{"dat-select-event":_vm.selectDatEvt}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"14%"}},[_c('date-item',{staticClass:"calenderitem",attrs:{"record":this.weekRecord.Fri},on:{"dat-select-event":_vm.selectDatEvt}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"14%"}},[_c('date-item',{staticClass:"calenderitem",attrs:{"record":this.weekRecord.Sat},on:{"dat-select-event":_vm.selectDatEvt}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"14%"}},[_c('date-item',{staticClass:"calenderitem",attrs:{"record":this.weekRecord.Sun},on:{"dat-select-event":_vm.selectDatEvt}})],1)])])],1),_vm._v(" "),(_vm.isHideCal)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"col-12"},[_c('v-calendar',{attrs:{"attributes":_vm.attrs,"min-date":new Date(),"mode":"single"},on:{"dayclick":_vm.dayClicked},model:{value:(_vm.myDate),callback:function ($$v) {_vm.myDate=$$v},expression:"myDate"}})],1)]):_vm._e(),_vm._v(" "),(_vm.freePaces.IsNextFreeApp)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24",staticStyle:{"margin-top":"4px","margin-bottom":"5px","text-align":"center"}},[_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.freePaces.NextFreePlaceMsg))])]),_vm._v(" "),_c('div',{staticClass:"col-24"},[_c('div',{staticClass:"product-btn",staticStyle:{"text-align":"center","margin-top":"10px"}},[_c('a',{staticStyle:{"color":"#fff"},style:({ 'background-color': _vm.getColorApp}),on:{"click":_vm.loadNextFreePlace}},[_c('i',{staticClass:"ion-calendar"}),_vm._v("Zoek naar volgende vrije plaats")])])])]):_vm._e(),_vm._v(" "),(!_vm.isHideCal)?_c('div',{staticClass:"row"},[(!_vm.isNoFreePlace)?_c('div',{staticClass:"col-24"},[_c('cart-free-place',{attrs:{"record":_vm.freePaces}})],1):_c('div',{staticClass:"col-24"},[_c('br'),_vm._v(" "),_c('h5',[_vm._v("Geen tijden beschikbaar")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Cart__ = __webpack_require__("oH0t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_ServiceDetail__ = __webpack_require__("EFmE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Categories__ = __webpack_require__("JIyO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_CategoriesList__ = __webpack_require__("NkVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_CartDate__ = __webpack_require__("1lRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_CustAppoint__ = __webpack_require__("cEKy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_StoreAppoint__ = __webpack_require__("GWkv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_MyAccount__ = __webpack_require__("gVLY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_MyAccountSend__ = __webpack_require__("ZlYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_CartConfirm__ = __webpack_require__("DHur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_CartReservationDone__ = __webpack_require__("vgS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Startup__ = __webpack_require__("z+Mq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_ErrorLoading__ = __webpack_require__("UzRZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_StoreClosed__ = __webpack_require__("qHjI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_PaymentStatus__ = __webpack_require__("knvK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_SingleSalon_SalonSelect__ = __webpack_require__("g5FY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_SingleSalon_SalonCategories__ = __webpack_require__("HsYR");





















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
//mode: 'history',

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({

  routes: [{
    path: '/',
    name: 'Startup',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Startup__["a" /* default */]
  }, {
    path: '/error',
    name: 'Errror',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_ErrorLoading__["a" /* default */]
  }, {
    path: '/listws',
    name: 'ListWs',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Categories__["a" /* default */]
  }, {
    path: '/list',
    name: 'List',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_CategoriesList__["a" /* default */]
  }, {
    path: '/cart',
    name: 'Cart',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Cart__["a" /* default */]
  }, {
    path: '/confirm',
    name: 'Confirm',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_CartConfirm__["a" /* default */]
  }, {
    path: '/salonselect',
    name: 'SalonSelect',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_SingleSalon_SalonSelect__["a" /* default */]
  }, {
    path: '/saloncategories',
    name: 'SalonCategories',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_SingleSalon_SalonCategories__["a" /* default */]
  }, {
    path: '/myaccount',
    name: 'MyAccount',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_MyAccount__["a" /* default */]
  }, {
    path: '/myaccountsend',
    name: 'MyAccountSend',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_MyAccountSend__["a" /* default */]
  }, {
    path: '/confirmed',
    name: 'ReservationDone',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_CartReservationDone__["a" /* default */]
  }, {
    path: '/servicedetail/:id',
    name: 'ServiceDetail',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_ServiceDetail__["a" /* default */]
  },, {
    path: '/category/:id',
    name: 'Category',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Categories__["a" /* default */]
  }, {
    path: '/dateappoint',
    name: 'DateAppoint',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_CartDate__["a" /* default */]
  }, {
    path: '/custappoint/:id',
    name: 'CustAppoint',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_CustAppoint__["a" /* default */]
  }, {
    path: '/storeappoint/:id',
    name: 'StoreAppoint',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_StoreAppoint__["a" /* default */]
  }, {
    path: '/paymentstatus/:id',
    name: 'PaymentStatus',
    component: __WEBPACK_IMPORTED_MODULE_16__pages_PaymentStatus__["a" /* default */]
  }, {
    path: '/storeclosed',
    name: 'StoreClosed',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_StoreClosed__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Yk5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-1"}),_vm._v(" "),_c('div',{staticClass:"col-22"},[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),(this.appoint.IsCanDelete)?_c('div',{staticClass:"product-btn"},[_c('div',{staticClass:"row hidesmall"},[_vm._v("  "),_c('strong',[_vm._v("Beste "+_vm._s(this.appoint.CustomerName))])]),_vm._v(" "),_c('div',{staticClass:"row hidesmall titleMenuBasket"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v("Wens je  "),_c('strong',[_vm._v("alle")]),_vm._v("  afspraken die doorgaan op "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(this.appoint.DateInfo)+" ")]),_vm._v("   afzeggen  ?")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"product-btn"},[_c('a',{staticStyle:{"color":"#fff","background-color":"#ff0000"},style:({ 'background-color': _vm.getColorApp}),on:{"click":_vm.cancelAppoint}},[_c('i',{staticClass:"ion-bag"}),_vm._v("NEE")]),_vm._v("   \n                    "),_c('a',{staticStyle:{"color":"#fff","background-color":"#ff0000"},on:{"click":_vm.deleteAppoint}},[_c('i',{staticClass:"ion-bag"}),_vm._v("JA")])])])]):_c('div',[_vm._v("\n                  "+_vm._s(this.appoint.Information)+"\n              ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(this.deletemsg))]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),(this.isShowNewApp)?_c('div',[_c('router-link',{staticClass:"product-link",attrs:{"to":'/'}},[_c('div',{staticClass:"product-btn"},[_c('a',{staticStyle:{"color":"#fff"},style:({ 'background-color': _vm.getColorApp})},[_c('i',{staticClass:"ion-ios-plus-empty"}),_vm._v("Maak een nieuwe afspraak op")])])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-1"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YoDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'startup',
  components: {},
  data: function data() {
    return {};
  },

  computed: {
    isAppError: function isAppError() {

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["s" /* SPINNER_HIDE */]);
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$errorStartup;
    }
  },
  methods: {},
  updated: function updated() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["s" /* SPINNER_HIDE */]);
  }
});

/***/ }),

/***/ "ZlYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccountSend_vue__ = __webpack_require__("b9rX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7089831a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccountSend_vue__ = __webpack_require__("bfdX");
function injectStyle (ssrContext) {
  __webpack_require__("JJXf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccountSend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7089831a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccountSend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aSR9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b9rX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__ = __webpack_require__("lpJF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product-list',
  props: ['products'],
  data: function data() {
    return {
      selTime: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime,
      cart: this.$store.state.cart,
      flgShowDet: false
    };
  },

  components: {
    cartItem: __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__["a" /* default */]
  },
  mounted: function mounted() {},

  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    }
  },
  methods: {
    navigate: function navigate(item) {
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      this.$router.go(-1);
    },
    resetAppoint: function resetAppoint() {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime = {};
      this.navigate('/');
    }
  }
});

/***/ }),

/***/ "bD9i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bLVN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'startup',
  components: {},
  data: function data() {
    return {};
  },

  computed: {
    isAppError: function isAppError() {

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["s" /* SPINNER_HIDE */]);
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$errorStartup;
    }
  },
  methods: {},
  updated: function updated() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["s" /* SPINNER_HIDE */]);
  }
});

/***/ }),

/***/ "bfdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._v("Indien je email is gekend in ons systeem en je hebt toekomstige afspraken staan in de agenda dan krijgt u een mail met al je afspraken er in. ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v("Indien u geen mail hebt ontvangen en je bent zeker dat jouw email gekend is in ons systeem. Controleer in dit geval dan ook eens je spam folder.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-24 contact-btn text-center"},[_c('div',{staticClass:"product-btn"},[_c('a',{style:({ 'background-color': _vm.getColorApp, color: '#fff'}),attrs:{"href":"/"}},[_c('i',{staticClass:"ion-person"}),_vm._v("  OK  ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bkBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.storeCustomer != undefined)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v("Afspraak opmaken voor "),_c('strong',[_vm._v(_vm._s(this.storeCustomer.FirstName)+"  "+_vm._s(this.storeCustomer.LastName))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[_c('category-list',{attrs:{"categories":_vm.subcategories,"products":_vm.products}})],1),_vm._v(" "),(_vm.isSubCat)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"}),_vm._v(" "),_c('router-link',{staticClass:"product-link",attrs:{"to":'/saloncategories'}},[_c('div',{staticClass:"product-btn"},[_c('a',[_c('i',{staticClass:"ion-arrow-left-c",staticStyle:{"color":"#111111"}}),_vm._v("Terug")])])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"product-link",attrs:{"to":"/salonselect"}},[_c('div',{staticClass:"product-btn",staticStyle:{"color":"#111111"}},[_c('a',[_c('i'),_vm._v("Kies een ander salon")])])])],1),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24",staticStyle:{"color":"#696969","text-align":"center","position":"absolute","bottom":"0","right":"50%"}},[_c('a',{staticStyle:{"color":"#696969","font-size":"small"},attrs:{"target":"_blank","href":"https://www.posworld.be"}},[_vm._v("Powered by Posworld")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bkWv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['product'],
  data: function data() {
    return {
      cart: this.$store.state.cart
    };
  },

  methods: {
    delItem: function delItem(id) {
      if (this.product.PackageID != undefined) {
        var pkg = this.product.PackageID;
        var pakitems = [];

        for (var s = 0; s < this.cart.length; s++) {
          if (this.cart[s].PackageID == pkg) {
            pakitems.push(this.cart[s]);
          }
        }

        for (var p = 0; p < pakitems.length; p++) {
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["p" /* REMOVE_FROM_CART */], pakitems[p]);
        }
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["p" /* REMOVE_FROM_CART */], this.product);
      }
    }
  }
});

/***/ }),

/***/ "cEKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustAppoint_vue__ = __webpack_require__("fBaQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f8b4c3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustAppoint_vue__ = __webpack_require__("Yk5+");
function injectStyle (ssrContext) {
  __webpack_require__("P4F5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustAppoint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f8b4c3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustAppoint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d14U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dPQA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__ = __webpack_require__("lpJF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cart_CartCheckout_vue__ = __webpack_require__("CUHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cart_CartDate_vue__ = __webpack_require__("gWNr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cart_SingleSalonCartDate_vue__ = __webpack_require__("8PfV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      meta: [{ name: 'description', content: this.metacontent }]
    };
  },

  name: 'product-list',
  props: ['products'],
  data: function data() {
    return {
      cart: this.$store.state.cart,
      storeCustomer: undefined,
      flgShowDet: true,
      title: 'Kies datum',
      metacontent: 'Kies een vrije plaats uit ',
      selectedSinleStore: undefined
    };
  },

  components: {
    cartItem: __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__["a" /* default */],
    'cart-datappoint': __WEBPACK_IMPORTED_MODULE_3__components_cart_CartDate_vue__["a" /* default */],
    'singlesalon-cart-datappoint': __WEBPACK_IMPORTED_MODULE_4__components_cart_SingleSalonCartDate_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.storeCustomer = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer;
    this.title = 'Kies datum - ' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName;
    this.metacontent = "Kies een vrije plaats bij " + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName;
    this.selectedSinleStore = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore;
  },

  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    }
  },
  methods: {
    getSalonAdres: function getSalonAdres(locationname) {
      var arr = locationname.split(",");
      if (arr.length > 1) return arr[1];
      return locationname;
    },
    navigate: function navigate(item) {
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      this.navigate('/cart');
    },
    showDetails: function showDetails() {
      this.flgShowDet = !this.flgShowDet;
    },
    getTotalsAdvance: function getTotalsAdvance() {
      var tot = 0;
      for (var c = 0; c < this.cart.length; c++) {
        tot += this.cart[c].PriceAdvance;
      }
      return tot;
    },
    getTotalsAdvancePrice: function getTotalsAdvancePrice() {
      var t = this.getTotalsAdvance();
      return t.toFixed(2);
    }
  }
});

/***/ }),

/***/ "divg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__ = __webpack_require__("JF0O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476b500a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__ = __webpack_require__("ADjw");
function injectStyle (ssrContext) {
  __webpack_require__("o28Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476b500a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dtLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"color":"#333c4a"}},[_c('i',{staticClass:"fa fa-trash-o",on:{"click":_vm.delItem}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eOjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-btn"},[_c('a',{on:{"click":_vm.addToCart}},[_c('i',{staticClass:"ion-plus"}),_vm._v(_vm._s(_vm.descr))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "egFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24"},[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row hidesmall titleMenuBasket"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"row hidesmall "},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-23 col-md-23"},[_vm._l((_vm.cart),function(product){return [_c('cart-item',{attrs:{"product":product,"hidedetails":true}})]})],2),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row hidesmall titleMenuBasket"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"row hidesmall"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"90%"}},[_c('h5',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.getSelectedDateInfo))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"90%"}},[_vm._v("om")]),_vm._v(" "),_c('div',{staticStyle:{"width":"90%"}},[_c('h2',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.getSelectedTimeInfo))])]),_vm._v(" "),_c('div',{staticClass:"row hidesmall"},[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"row hidesmall"},[_vm._v(" ")]),_vm._v(" "),(this.selectedSinleStore != undefined)?_c('div',{staticStyle:{"text-align":"center","background-color":"#dedede","padding-top":"10px","border-radius":"10px","padding-bottom":"5px","margin-bottom":"10px"}},[_c('div',{staticStyle:{"width":"90%"}},[_vm._v("Je afspraak gaat door in salon")]),_vm._v(" "),_c('div',{staticStyle:{"width":"90%"}},[_c('h3',{staticStyle:{"font-weight":"bold","font-size":"17px"}},[_vm._v(_vm._s(this.selectedSinleStore.UserName))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"90%"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"90%"}},[_c('h5',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.getSalonAdres (this.selectedSinleStore.Location)))])]),_vm._v(" "),_c('div',{staticClass:"row hidesmall"},[_vm._v(" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row hidesmall"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"product-btn",staticStyle:{"color":"#111111"}},[_c('a',{on:{"click":function($event){return _vm.navigateBack();}}},[_c('i',{staticClass:"ion-arrow-left-c",staticStyle:{"color":"#111111"}}),_vm._v("Terug")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24"},[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row hidesmall titleMenuBasket"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"contact-message pt-20 pt-sm-20"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-24"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstname),expression:"firstname"}],attrs:{"name":"first_name","placeholder":"Voornaam *","type":"text"},domProps:{"value":(_vm.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-24"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastname),expression:"lastname"}],attrs:{"name":"last_name","placeholder":"Achternaam *","type":"text"},domProps:{"value":(_vm.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-24"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mail),expression:"mail"}],attrs:{"name":"email_address","placeholder":"Email *","type":"text"},domProps:{"value":(_vm.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-24"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],attrs:{"name":"phone","placeholder":"Telefoon *","type":"text"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-24 col-md-24 col-sm-24 col-xs-24"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.custaddress),expression:"custaddress"}],attrs:{"name":"cust_address","placeholder":"Adresgegevens *","type":"text"},domProps:{"value":(_vm.custaddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.custaddress=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-24"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.custzipcode),expression:"custzipcode"}],attrs:{"name":"cust_zipcode","placeholder":"Postcode *","type":"text"},domProps:{"value":(_vm.custzipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.custzipcode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-24"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.custcity),expression:"custcity"}],attrs:{"name":"cust_city","placeholder":"Stad *","type":"text"},domProps:{"value":(_vm.custcity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.custcity=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-24"},[_c('div',{staticClass:"contact2-textarea text-center"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"form-control2",staticStyle:{"height":"80px"},attrs:{"placeholder":"Opmerking","name":"message","required":""},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})])]),_vm._v(" "),(_vm.prcTotal > 0)?_c('div',{staticClass:"col-lg-23 col-sm-24 col-xs-24"},[(_vm.prcTotal > 0)?_c('div',{staticClass:"row",staticStyle:{"background-color":"#999999","height":"30px","line-height":"30px","border-radius":"5px","padding-left":"5px"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-6",staticStyle:{"color":"#ffffff","text-align":"right"}},[_vm._v("€"+_vm._s(_vm.getTotalsAdvancePrice ())+"  ")])]):_vm._e(),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-24 contact-btn text-center"},[_c('div',{staticClass:"product-btn"},[_c('a',{style:({ 'background-color': _vm.getColorApp, color: '#fff'}),on:{"click":_vm.saveAppointment}},[_c('i',{staticClass:"ion-bag"}),_vm._v(_vm._s(_vm.kindMsgContinue))])])]),_vm._v(" "),_c('div',{staticClass:"col-24",staticStyle:{"height":"40px"}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row hidesmall"},[_vm._v("  "),_c('h5',[_vm._v("Jouw behandelingen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row hidesmall"},[_vm._v("  "),_c('h5',[_vm._v("Datum reservatie")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._v("  "),_c('h5',{staticStyle:{"font-weight":"bold"}},[_vm._v("Reservatie")]),_vm._v("\n              Vul je gegevens hieronder in en klik dan op de knop \"Afspraak bevestigen!\"\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-18"},[_c('strong',{staticStyle:{"color":"#ffffff"}},[_vm._v("Totaal voorschot gevraagd van ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f84z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"product-btn col-24",staticStyle:{"text-align":"center"}},[(_vm.isAppError === true)?_c('div',[_vm._m(0)]):_c('div',[_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/"}},[_c('i',{staticClass:"ion-refresh"}),_vm._v("Probeer opnieuw")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"ion-refresh"}),_vm._v("Probeer opnieuw")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fBaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      appoint: {},
      deletemsg: '',
      isDeleted: false,
      isShowNewApp: false,
      id: this.$route.params['id']
    };
  },
  mounted: function mounted() {
    this.loadMyAppointments();
  },

  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    }
  },
  methods: {
    cancelAppoint: function cancelAppoint() {
      document.location = "/";
    },
    loadMyAppointments: function loadMyAppointments() {
      var _this = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["r" /* SPINNER_SHOW */]);
      var searchRec = { Token: this.id };
      __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */].post('Account/GetAppointment', searchRec).then(function (response) {
        _this.appoint = response.data;

        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* SPINNER_HIDE */]);
      }).catch(function (error) {
        console.log(error);
        _this.appoint = [];
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* SPINNER_HIDE */]);
      });
    },
    deleteAppoint: function deleteAppoint() {
      var _this2 = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["r" /* SPINNER_SHOW */]);
      var searchRec = { Token: this.appoint.Token };
      __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */].post('Account/DelAppointment', searchRec).then(function (response) {
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* SPINNER_HIDE */]);
        _this2.appoint.IsCanDelete = false;
        if (response.data.ResultCode == 0) {
          _this2.deletemsg = "Je afspraak is geannuleerd";
        } else {
          _this2.deletemsg = response.data.ErrorMsg;
        }
        _this2.isShowNewApp = true;
      }).catch(function (error) {
        console.log(error);
        _this2.appoint.IsCanDelete = false;
        deletemsg = "Fout bij verwerken";
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* SPINNER_HIDE */]);
        _this2.isShowNewApp = true;
      });
    }
  }
});

/***/ }),

/***/ "fPMW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fqtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDateItem_vue__ = __webpack_require__("3tHK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e539d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDateItem_vue__ = __webpack_require__("KYnK");
function injectStyle (ssrContext) {
  __webpack_require__("V6LE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDateItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e539d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDateItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g5FY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalonSelect_vue__ = __webpack_require__("m8jB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce8a9a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalonSelect_vue__ = __webpack_require__("QveT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalonSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce8a9a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalonSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gVLY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccount_vue__ = __webpack_require__("Fk4A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16098a92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccount_vue__ = __webpack_require__("F5kq");
function injectStyle (ssrContext) {
  __webpack_require__("TfQs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16098a92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gWNr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDate_vue__ = __webpack_require__("4o6d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_667c360a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDate_vue__ = __webpack_require__("XZtv");
function injectStyle (ssrContext) {
  __webpack_require__("VPq6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_667c360a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gdtt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['record', 'canGoNext'],
  data: function data() {
    return {
      selectedTime: undefined,
      showfreeplaces: true,
      canGoNextPage: false
    };
  },

  components: {},
  mounted: function mounted() {
    this.canGoNextPage = this.canGoNext;
    this.showfreeplaces = true;
  },

  computed: {
    canContinue: function canContinue() {
      if (!this.canGoNextPage) {
        this.showfreeplaces = true;
      }
      return this.canGoNextPage;
    },
    getFreeTimes: function getFreeTimes() {
      this.showfreeplaces = true;
      return this.record.Records;
    },
    getColorApp: function getColorApp() {
      if (this.selectedTime == undefined) return "#ebebeb";

      if (!this.selectedTime.IsSelected) {
        return "#ebebeb";
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.ColorApp;
      }
    }
  },
  methods: {
    checkOut: function checkOut() {
      //this.$router.push('/custappoint');
    },
    freePlaceClicked: function freePlaceClicked(item) {
      console.log(item.TimeInfo);
      item.IsSelected = true;
      this.canGoNextPage = true;
      this.selectedTime = item;
      this.showfreeplaces = false;
    },
    confirmReservation: function confirmReservation() {
      if (this.canGoNextPage) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$selectedTime = this.selectedTime;
        this.$router.push('/confirm');
      } else {
        alert("Kies een tijdstip aub");
      }
    },
    buttonStyles: function buttonStyles() {
      return {
        backgroundColor: this.selectedTime.IsSelected ? __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.ColorApp : "#ddd"
      };
    }
  }
});

/***/ }),

/***/ "gl21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductButton_vue__ = __webpack_require__("HJds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product-item',
  props: ['product'],
  components: {
    'product-button': __WEBPACK_IMPORTED_MODULE_0__ProductButton_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlPicCat: '',
      isHideTime: false,
      isHidePrice: false
    };
  },
  mounted: function mounted() {
    this.urlPicCat = '';
    this.urlPicCat = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$currCatPicUrl;

    if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings != undefined) {
      this.isHideTime = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsHideTime;
      this.isHidePrice = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsHidePrice;
    }

    // console.log ("loading pic 1:" + Vue.$currCatPicUrl)
  },
  activated: function activated() {
    //console.log ("loading pic :" + Vue.$currCatPicUrl)
    this.urlPicCat = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$currCatPicUrl;
  },

  methods: {
    getDuration: function getDuration() {
      if (this.isHideTime) return " ";
      if (this.product.IntDuration <= 0) return "  ";
      return this.product.IntDuration + " min.";
    },
    getProdPrice: function getProdPrice() {
      if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$storeSettings.IsHidePrices) return " ";
      if (parseFloat(this.product.Price) == 0) return " op aanvraag ";
      var p = parseFloat(this.product.Price);
      return "€" + p.toFixed(2);
    },
    getPackageData: function getPackageData() {
      var ret = "";
      for (var c = 0; c < this.product.Childs.length; c++) {
        ret += this.product.Childs[c].Title + " | ";
      }
      return ret;
    }
  },
  computed: {
    hasPackageData: function hasPackageData() {
      this.urlPicCat = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$currCatPicUrl;
      if (this.product.Childs == null) {
        return false;
      }
      if (this.product.Childs.length > 0) {
        return true;
      }
      return false;
    },
    getPicture: function getPicture() {
      this.urlPicCat = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$currCatPicUrl;
      return this.urlPicCat; //Vue.$currCatPicUrl;
    }
  }
});

/***/ }),

/***/ "hEb3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hj3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hn0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartItemUser_vue__ = __webpack_require__("x/X7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6243952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartItemUser_vue__ = __webpack_require__("4Tgy");
function injectStyle (ssrContext) {
  __webpack_require__("d14U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartItemUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6243952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartItemUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "irNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.selectedSinleStore != undefined)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v("Afspraak opmaken in salon "),_c('strong',[_vm._v(_vm._s(this.selectedSinleStore.UserName))]),_vm._v(" "),_c('br'),_vm._v(" "+_vm._s(_vm.getSalonAdres (this.selectedSinleStore.Location)))])])]):_vm._e(),_vm._v(" "),(this.storeCustomer != undefined)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v("Afspraak opmaken voor "),_c('strong',[_vm._v(_vm._s(this.storeCustomer.FirstName)+"  "+_vm._s(this.storeCustomer.LastName))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row hidesmall titleMenuBasket",style:({ 'background-color': _vm.getColorApp})},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"row hidesmall "},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-23 col-sm-24"},[_vm._l((_vm.cart),function(product){return [(_vm.flgShowDet)?_c('cart-item',{attrs:{"product":product,"hidedetails":true}}):_vm._e()]})],2),_vm._v(" "),(_vm.getTotalsAdvance () > 0)?_c('div',{staticClass:"col-lg-23 col-sm-24"},[_c('hr'),_vm._v(" "),(_vm.getTotalsAdvance () > 0)?_c('div',{staticClass:"row",staticStyle:{"background-color":"#999999","height":"30px","line-height":"30px","border-radius":"5px","padding-left":"5px"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-6",staticStyle:{"color":"#ffffff","text-align":"right"}},[_vm._v("€"+_vm._s(_vm.getTotalsAdvancePrice ())+"  ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"product-btn",staticStyle:{"color":"#111111"}},[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.navigateBack();}}},[(_vm.flgShowDet)?_c('i',{staticClass:"ion-arrow-left-c",staticStyle:{"color":"#111111"}}):_vm._e(),_vm._v("Terug")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24"},[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row titleMenuBasket",style:({ 'background-color': _vm.getColorApp})},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),(_vm.selectedSinleStore === undefined)?_c('cart-datappoint'):_vm._e(),_vm._v(" "),(_vm.selectedSinleStore !== undefined)?_c('singlesalon-cart-datappoint'):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row hidesmall"},[_vm._v("  "),_c('h5',[_vm._v("Mijn behandelingen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-18"},[_c('strong',{staticStyle:{"color":"#ffffff"}},[_vm._v("Totaal voorschot gevraagd van ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._v("  "),_c('h5',[_vm._v("Kies een datum")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j+8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryList_vue__ = __webpack_require__("z257");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d50295_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryList_vue__ = __webpack_require__("xg+1");
function injectStyle (ssrContext) {
  __webpack_require__("bD9i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d50295_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jlnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppWebsiteV10_vue__ = __webpack_require__("7giP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_022cb311_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppWebsiteV10_vue__ = __webpack_require__("kFt+");
function injectStyle (ssrContext) {
  __webpack_require__("JPir")
  __webpack_require__("ldSe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-022cb311"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppWebsiteV10_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_022cb311_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppWebsiteV10_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kCsH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__ = __webpack_require__("lpJF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cart_CartCheckout_vue__ = __webpack_require__("CUHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: {
    title: 'Afspraak bevestigen'
  },
  name: 'product-list',
  props: ['products'],
  data: function data() {
    return {
      cart: this.$store.state.cart,
      flgShowDet: false,
      firstname: '',
      lastname: '',
      mail: '',
      phone: '',
      message: '',
      custaddress: '',
      custcity: '',
      custzipcode: '',
      kindMsgContinue: '',
      token: '',
      prcTotal: 0,
      selectedSinleStore: undefined
    };
  },

  components: {
    cartItem: __WEBPACK_IMPORTED_MODULE_1__components_cart_CartItem__["a" /* default */]
  },
  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    },
    getSelectedTime: function getSelectedTime() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime;
    },
    getSelectedTimeInfo: function getSelectedTimeInfo() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime.TimeInfo;
    },
    getSelectedDateInfo: function getSelectedDateInfo() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime.DateInfo;
    }
  },
  mounted: function mounted() {
    this.firstname = "";
    this.lastname = "";
    this.mail = "";
    this.phone = "";
    this.message = "";
    this.custaddress = "";
    this.custcity = "";
    this.custzipcode = "";
    this.token = "";
    this.kindMsgContinue = "Afspraak bevestigen";

    this.selectedSinleStore = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore;

    if (localStorage.firstname) {
      this.firstname = localStorage.firstname;
    }
    if (localStorage.lastname) {
      this.lastname = localStorage.lastname;
    }
    if (localStorage.phone) {
      this.phone = localStorage.phone;
    }
    if (localStorage.mail) {
      this.mail = localStorage.mail;
    }
    if (localStorage.message) {
      this.message = localStorage.message;
    }
    if (localStorage.custaddress) {
      this.custaddress = localStorage.custaddress;
    }
    if (localStorage.custcity) {
      this.custcity = localStorage.custcity;
    }
    if (localStorage.custzipcode) {
      this.custzipcode = localStorage.custzipcode;
    }

    this.prcTotal = this.getTotalsAdvance();
    this.fullCustomerFromStore();
  },

  methods: {
    isTrimSalon: function isTrimSalon() {
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.KindStore === undefined) return false;
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.KindStore === 15) return true;
      return false;
    },
    isHasAnimalsEntered: function isHasAnimalsEntered() {
      for (var c = 0; c < this.cart.length; c++) {
        if (this.cart[c].Extra === undefined) return false;
        if (this.cart[c].Extra.length <= 1) return false;
      }
      return true;
    },
    getSalonAdres: function getSalonAdres(locationname) {
      var arr = locationname.split(",");
      if (arr.length > 1) return arr[1];
      return locationname;
    },
    navigate: function navigate(item) {
      this.$router.push(item);
    },
    getTotalsAdvance: function getTotalsAdvance() {
      var tot = 0;
      console.log("L1");
      for (var c = 0; c < this.cart.length; c++) {
        tot += this.cart[c].PriceAdvance;
      }
      console.log("L2");

      this.kindMsgContinue = "Afspraak bevestigen";
      if (tot != 0) this.kindMsgContinue = "Betaal en bevestig";

      return tot;
    },
    getTotalsAdvancePrice: function getTotalsAdvancePrice() {
      var t = this.prcTotal;
      return t.toFixed(2);
    },
    fullCustomerFromStore: function fullCustomerFromStore() {

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer == undefined) {
        return;
      }

      this.firstname = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer.FirstName;
      this.mail = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer.Email;
      this.phone = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer.Phone;
      this.lastname = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer.LastName;
      this.custaddress = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer.Address;
      this.custzipcode = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer.ZipCode;
      this.custcity = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer.City;
      this.token = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer.Token;
      this.message = "";
    },
    navigateBack: function navigateBack() {
      this.navigate("/dateappoint");
    },
    showDetails: function showDetails() {
      this.flgShowDet = !this.flgShowDet;
    },
    startPayment: function startPayment(keyPayment) {
      var _this = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["r" /* SPINNER_SHOW */]);

      var token = { Search: keyPayment };

      __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__["a" /* default */].post('Basket/StartPayment', token).then(function (response) {
        var result = response.data;

        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["s" /* SPINNER_HIDE */]);

        if (result.ResultCode == 200) {
          document.location = result.ErrorMsg;
        }
      });
    },
    saveAppointment: function saveAppointment() {
      var _this2 = this;

      if (this.isTrimSalon()) {
        if (!this.isHasAnimalsEntered()) {
          alert("Dier naam ontbreekt");
          return;
        }
      }

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["r" /* SPINNER_SHOW */]);
      localStorage.firstname = this.firstname;
      localStorage.lastname = this.lastname;
      localStorage.phone = this.phone;
      localStorage.mail = this.mail;
      localStorage.message = this.message;
      localStorage.custaddress = this.custaddress;
      localStorage.custzipcode = this.custzipcode;
      localStorage.custcity = this.custcity;

      var cust = { FirstName: this.firstname, LastName: this.lastname, Email: this.mail, Phone: this.phone, ExtraMessage: this.message,
        Address: this.custaddress, ZipCode: this.custzipcode, City: this.custcity };
      var appointRec = { DatReservation: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedTime.Date, BasketItems: this.cart, Customer: cust, Token: this.token };
      __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__["a" /* default */].post('Basket/SaveReservation', appointRec).then(function (response) {
        var result = response.data;
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["s" /* SPINNER_HIDE */]);
        if (result.ResultCode == 0) {

          // this.$store.state.cart = [];
          _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["q" /* CLEAR_CART */]);
          _this2.navigate("/confirmed");
        } else if (result.ResultCode == 2) {
          alert(result.ErrorMsg);
          //this.$router.go (-1);
          _this2.navigate("/DateAppoint");
        } else if (result.ResultCode == 15) {
          _this2.startPayment(result.ErrorMsg);
        } else {
          alert(result.ErrorMsg);
        }
      }).catch(function (error) {
        console.log(error);
        _this2.freePaces = [];
        alert(error);
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["s" /* SPINNER_HIDE */]);
      });
    }
  }
});

/***/ }),

/***/ "kFt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'background-color': _vm.baseColor}),attrs:{"id":"app"}},[_c('main',{staticStyle:{"background-color":"#ffffff"},attrs:{"id":"start"}},[_c('div',{staticClass:"contact-top-area",staticStyle:{"background-color":"#ffffff"}},[(!_vm.isPamentPage)?_c('div',{staticClass:"row",staticStyle:{"display":"block","margin":"auto"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticStyle:{"display":"block","margin":"auto"},attrs:{"src":_vm.picture}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"text-center pt-20 pb-20",style:({'background-color': _vm.baseColor})},[_c('a',{attrs:{"href":"/"}},[_c('h1',{staticStyle:{"color":"#ffffff"}},[_vm._v(_vm._s(_vm.storename))])])])]),_vm._v(" "),(!_vm.isPamentPage)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row pt-30"},[_c('div',{staticClass:"col-lg-24 col-md-24 col-sm-24"},[_c('div',{staticClass:"footer-widget"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"footer-widget-body"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.welcomemsg)}})])])])]),_vm._v(" "),_c('div',{staticClass:"row pt-30"})]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#ffffff"}},[(_vm.onlinesresclosed === false)?_c('div',{staticClass:"container anchor",attrs:{"id":"reserveer"}},[_vm._m(1)]):_vm._e()]),_vm._v(" "),(_vm.onlinesresclosed === false)?_c('appReservation',{staticStyle:{"background-color":"#fafafa","padding-top":"10px","padding-bottom":"15px"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container anchor",staticStyle:{"background-color":"#ffffff"},attrs:{"id":"contact"}},[_c('div',{staticClass:"row pt-20"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6 col-xs-12"},[_c('div',{staticClass:"contact-single-info mb-30 text-center"},[_c('div',{staticClass:"contact-icon",style:({'background-color': _vm.baseColor})},[_c('i',{staticClass:"fa fa-map-marker"})]),_vm._v(" "),_c('h3',[_vm._v("Adresgegevens")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.address1)),_c('br'),_vm._v(_vm._s(_vm.address2))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6 col-xs-12"},[_c('div',{staticClass:"contact-single-info mb-30 text-center"},[_c('div',{staticClass:"contact-icon",style:({'background-color': _vm.baseColor})},[_c('i',{staticClass:"fa fa-phone"})]),_vm._v(" "),_c('h3',[_vm._v("Contact")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.phone)),_c('br'),_vm._v(_vm._s(_vm.mobile))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6 col-xs-12"},[_c('div',{staticClass:"contact-single-info mb-30 text-center"},[_c('div',{staticClass:"contact-icon",style:({'background-color': _vm.baseColor})},[_c('i',{staticClass:"fa fa-facebook"})]),_vm._v(" "),_c('h3',[_vm._v("Social")]),_vm._v(" "),_c('p',[_c('a',{staticStyle:{"color":"#111111"},attrs:{"href":_vm.facebookurl,"target":"_blank"}},[_vm._v("Facebook")])]),_vm._v(" "),(_vm.hasinstagram)?_c('p',{staticStyle:{"color":"#111111"}},[_c('a',{staticStyle:{"color":"#111111"},attrs:{"href":_vm.instagramurl,"target":"_blank"}},[_vm._v("Instagram")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6 col-xs-12"},[(_vm.openhours.length > 5)?_c('div',{staticClass:"contact-single-info mb-30"},[_c('h3',[_vm._v("Openingsuren")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.openhours)}})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#fafafa"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",staticStyle:{"background-color":"#fafafa"}},[_c('div',{staticClass:"col-xl-20 col-lg-24 m-auto"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"contact-message pt-60 pt-sm-20"},[(!_vm.flgContactSend)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientname),expression:"clientname"}],attrs:{"name":"first_name","placeholder":"Naam *","type":"text"},domProps:{"value":(_vm.clientname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientphone),expression:"clientphone"}],attrs:{"name":"phone","placeholder":"Telefoon *","type":"text"},domProps:{"value":(_vm.clientphone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientphone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientmail),expression:"clientmail"}],attrs:{"name":"email_address","placeholder":"Email *","type":"text"},domProps:{"value":(_vm.clientmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientmail=$event.target.value}}})]),_vm._v(" "),(_vm.captchaimg.length > 100)?_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[(_vm.captchaimg.length > 100)?_c('img',{attrs:{"src":_vm.captchaimg}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.captchacode),expression:"captchacode"}],attrs:{"name":"captchacode","placeholder":"code","type":"text"},domProps:{"value":(_vm.captchacode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.captchacode=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-24"},[_c('div',{staticClass:"contact2-textarea text-center"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientmessage),expression:"clientmessage"}],staticClass:"form-control2",attrs:{"placeholder":"Bericht *","name":"message","required":""},domProps:{"value":(_vm.clientmessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientmessage=$event.target.value}}})]),_vm._v(" "),(_vm.captchaimg.length > 100)?_c('div',{staticClass:"contact-btn text-center"},[_c('button',{staticClass:"check-btn sqr-btn",style:({'background-color': _vm.baseColor}),attrs:{"disabled":_vm.disableSendMsg,"type":"submit"},on:{"click":function($event){_vm.sendContact ()}}},[_vm._v("Verzenden")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center pt-20"},[_c('h3',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.errormsg))])])])]):_vm._e(),_vm._v(" "),(_vm.flgContactSend)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"text-center pt-20"},[_c('h3',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.errormsg))])])]):_vm._e()])])])])])],1)]),_vm._v(" "),_c('footer',[_c('div',{staticClass:"footer-widget-area pt-30 pb-30 pb-md-20 pt-sm-36 pb-sm-10"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24"},[_c('div',{staticClass:"footer-widget"},[(_vm.bottomtitle1.length > 2)?_c('div',{staticClass:"footer-widget-title"},[_c('h3',{staticStyle:{"color":"#eeeeee"}},[_vm._v(_vm._s(_vm.bottomtitle1))])]):_vm._e(),_vm._v(" "),(_vm.bottommsg1.length > 10)?_c('div',{staticClass:"footer-widget-body"},[_c('span',{staticClass:"footermsg",domProps:{"innerHTML":_vm._s(_vm.bottommsg1)}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24"},[_c('div',{staticClass:"footer-widget"},[(_vm.bottomtitle2.length > 2)?_c('div',{staticClass:"footer-widget-title"},[_c('h3',{staticStyle:{"color":"#eeeeee"}},[_vm._v(_vm._s(_vm.bottomtitle2))])]):_vm._e(),_vm._v(" "),(_vm.bottommsg2.length > 10)?_c('div',{staticClass:"footer-widget-body"},[_c('span',{staticStyle:{"color":"#ffffff"},domProps:{"innerHTML":_vm._s(_vm.bottommsg2)}})]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row pt-10",staticStyle:{"color":"#dddddd","text-align":"center"}},[_vm._v("Powered by    "),_c('a',{staticStyle:{"color":"#ffffff"},attrs:{"href":"https://www.posworld.be","target":"_blank"}},[_vm._v("Posworld")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"smaller"}},[_vm._v("  "+_vm._s(_vm.versionApp))])])])]),_vm._v(" "),_c('div',{staticClass:"scroll-top not-visible",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fa fa-angle-up"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title "},[_c('h2',[_vm._v("WELKOM")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row  pt-30"},[_c('div',{staticClass:"footer-widget"},[_c('div',{staticClass:"section-title "},[_c('h2',[_vm._v("RESERVEER ONLINE")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pt-30"},[_c('div',{staticClass:"col-24"},[_c('div',{staticClass:"section-title "},[_c('h2',[_vm._v("ZEND EEN BERICHT")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "knvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentStatus_vue__ = __webpack_require__("unrC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57cdda9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentStatus_vue__ = __webpack_require__("B4Rf");
function injectStyle (ssrContext) {
  __webpack_require__("hEb3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57cdda9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ldSe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "loOH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSalonReservation_vue__ = __webpack_require__("2sja");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_346636de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSalonReservation_vue__ = __webpack_require__("JWvG");
function injectStyle (ssrContext) {
  __webpack_require__("AZDo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSalonReservation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_346636de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSalonReservation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lpJF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartItem_vue__ = __webpack_require__("zE6B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f8039a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartItem_vue__ = __webpack_require__("tH8+");
function injectStyle (ssrContext) {
  __webpack_require__("5Ya6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56f8039a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f8039a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m8jB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_products_ProductList_vue__ = __webpack_require__("divg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_categories_CategoryList_vue__ = __webpack_require__("j+8l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__ = __webpack_require__("G8sS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    'product-list': __WEBPACK_IMPORTED_MODULE_1__components_products_ProductList_vue__["a" /* default */],
    'category-list': __WEBPACK_IMPORTED_MODULE_2__components_categories_CategoryList_vue__["a" /* default */]
  },
  data: function data() {
    return {
      storeCustomer: undefined,
      calendars: [],
      fullPage: false
    };
  },
  created: function created() {
    document.title = "Reserveer online bij " + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName;
  },

  methods: {
    navigate: function navigate(item) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore = item;
      this.$router.push('/saloncategories');
    },
    navigateBack: function navigateBack() {
      this.$router.go(-1);
    },
    getSalonAdres: function getSalonAdres(locationname) {
      var arr = locationname.split(",");
      if (arr.length > 1) return arr[1];
      return locationname;
    }
  },
  computed: {
    getCalendars: function getCalendars() {
      console.log("loading calendars");
      this.calendars = this.$store.getters.allCalendars;
      return this.calendars;
    }
  },
  watch: {
    '$route': function $route(to, from) {}
  },
  mounted: function mounted() {
    this.storeCustomer = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer;
  }
});

/***/ }),

/***/ "mPQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppError_vue__ = __webpack_require__("/rm6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c7f9c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppError_vue__ = __webpack_require__("Mvau");
function injectStyle (ssrContext) {
  __webpack_require__("SqJY")
  __webpack_require__("MuCY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67c7f9c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c7f9c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return manufacturerActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");
// ./src/store/actions



var API_BASE = 'https://api/v1/';



var productActions = {
  getServiceUsers: function getServiceUsers(_ref, product) {
    var commit = _ref.commit;

    commit(ALL_USERS_FORSERVICE);

    var searchRec = { Search: product.ArticleID, Extra: "" };
    __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */].post('Service/ServiceUsers', searchRec).then(function (response) {
      commit(ALL_USERS_FORSERVICE_SUCCESS, response.data);
    }).catch(function (error) {
      console.log(error);
    });
  },
  allProducts: function allProducts(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ALL_PRODUCTS */]);
    // Fetch actual products from the API
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_BASE + '/products').then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ALL_PRODUCTS_SUCCESS */], response.data);
    });
  },
  productById: function productById(_ref3, payload) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* PRODUCT_BY_ID */]);
    // Fetch product by ID from API
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_BASE + '/products/' + payload).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* PRODUCT_BY_ID_SUCCESS */], response.data);
    });
  },
  addProduct: function addProduct(_ref4, payload) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* ADD_PRODUCT */]);
    // Create a new product via API
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(API_BASE + '/products', payload).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* ADD_PRODUCT_SUCCESS */], response.data);
    });
  },
  updateProduct: function updateProduct(_ref5, payload) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* UPDATE_PRODUCT */]);
    // Update product via API
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(API_BASE + '/products/' + payload._id, payload).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* UPDATE_PRODUCT_SUCCESS */], response.data);
    });
  },
  removeProduct: function removeProduct(_ref6, payload) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* REMOVE_PRODUCT */]);
    // Delete product via API
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(API_BASE + '/products/' + payload, payload).then(function (response) {
      console.debug('response', response.data);
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* REMOVE_PRODUCT_SUCCESS */], response.data);
    });
  },
  allCategories: function allCategories(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* ALL_CATEGORIES */]);
    __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */];

    var searchRec = { Search: "", Extra: "" };
    __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */].post('Service/GetCategories', searchRec).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* ALL_CATEGORIES_SUCCESS */], response.data);
    }).catch(function (error) {
      console.log(error);
    });
  },
  allCalendars: function allCalendars(_ref8) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* ALL_CALENDARS */]);
    __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */];
    __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */].post('Settings/GetCalendars').then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* ALL_CALENDARS_SUCCESS */], response.data);
    }).catch(function (error) {
      console.log(error);
    });
  }
};

var manufacturerActions = {
  allManufacturers: function allManufacturers(_ref9) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* ALL_MANUFACTURERS */]);
    // Fetch all manufacturers from API
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_BASE + '/manufacturers').then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* ALL_MANUFACTURERS_SUCCESS */], response.data);
    });
  }
};

/***/ }),

/***/ "nzlO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"product-list-item mb-20"},[_c('div',{staticClass:"product-thumb"},[_c('a',[_c('img',{attrs:{"src":_vm.getPicture,"alt":_vm.product.Title}})]),_vm._v(" "),_c('div',{staticClass:"box-label"},[(this.hasPackageData)?[_vm._m(0)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"product-action-link"})]),_vm._v(" "),_c('div',{staticClass:"product-list-content col-lg-18 col-md-18 col-sm-18 col-xs-12"},[_c('h3',[_vm._v(_vm._s(_vm.product.Title))]),_vm._v(" "),(!_vm.isHideTime)?_c('h5',[_vm._v(_vm._s(this.totalDurationInfoMsg)+" "+_vm._s(_vm.product.IntDuration)+" min.")]):_vm._e(),_vm._v(" "),(!_vm.getPrice)?_c('div',{staticClass:"pricebox"},[_c('span',{staticClass:"regular-price"},[_vm._v("€"+_vm._s(_vm.product.Price)+" incl. BTW")])]):_vm._e(),_vm._v(" "),(this.hasPackageData)?[_c('br'),_vm._v(" "),_c('h5',{staticStyle:{"font-weight":"bold"}},[_vm._v("Dit pakket bevat volgende behandelingen")]),_vm._v(" "),_c('ul',[_vm._l((_vm.product.Childs),function(serv){return [_c('li',[_vm._v(_vm._s(serv.Title))])]})],2)]:_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"product-btn"},[_c('product-button',{attrs:{"product":_vm.product}})],1)],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-1"}),_vm._v(" "),_c('router-link',{staticClass:"product-link",attrs:{"to":'/'}},[_c('div',{staticClass:"row product-btn"},[_c('a',[_c('i',{staticClass:"ion-arrow-left-c"}),_vm._v("Terug")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-label new"},[_c('span',[_vm._v("PAKKET")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o28Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oH0t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__("4bWa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bac69b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__("yI0E");
function injectStyle (ssrContext) {
  __webpack_require__("OnzC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bac69b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pEla":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pqTy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q+kS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('at-collapse',{attrs:{"accordion":"","value":0}},_vm._l((this.$store.getters.allCategories),function(item){return _c('at-collapse-item',{style:({ 'background-color': _vm.getColorApp}),attrs:{"name":'mnu' + item.CategoryID}},[_c('div',{style:({ 'background-color': _vm.getColorApp}),attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.Title))]),_vm._v(" "),_c('div',[_vm._l((item.SubCat),function(submenu){return (item.SubCat.length > 0)?_c('div',[_c('at-collapse',{attrs:{"accordion":"","value":0,"name":'submnublock' + item.CategoryID}},[_c('at-collapse-item',{staticStyle:{"margin-bottom":"2px"},style:({ 'background-color': _vm.getColorApp}),attrs:{"name":'subcat' + submenu.CategoryID}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(submenu.Title))]),_vm._v(" "),_c('div',_vm._l((submenu.Services),function(subserv){return _c('div',{staticClass:"row at-row no-gutter bottomline"},[_c('div',{class:'col-16'},[(subserv.IsPackage)?_c('div',[_c('at-badge',{attrs:{"value":"PAKKET"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(subserv.Title))]),_vm._v(" "),_c('ul',[_vm._l((subserv.Childs),function(serv){return [_c('li',[_vm._v(" - "+_vm._s(serv.Title))])]})],2)],1):_c('div',[_vm._v(_vm._s(subserv.Title))]),_vm._v(" "),(subserv.Detail.length > 1)?_c('span',[_c('small',[_vm._v(_vm._s(subserv.Detail))])]):_vm._e()]),_vm._v(" "),_c('div',{class:'col-3'},[_c('div',{staticClass:"at-box-row bg-c-brand-light"},[_vm._v(" "+_vm._s(subserv.IntDuration)+" min.")])]),_vm._v(" "),_c('div',{class:'col-3'},[_c('div',{staticClass:"at-box-row bg-c-brand-light"},[(!_vm.getPrice)?_c('span',[_vm._v(" € "+_vm._s(subserv.Price))]):_vm._e()])]),_vm._v(" "),_c('div',{class:'col-2'},[_c('div',{staticClass:"at-box-row bg-c-brand-light"},[_c('at-button',{attrs:{"size":"smaller","icon":"icon-chevron-right","circle":""},on:{"click":function($event){_vm.addToCart (subserv)}}})],1)])])}),0)])],1)],1):_vm._e()}),_vm._v(" "),_c('div',{attrs:{"else":""}}),_vm._v(" "),_vm._l((item.Services),function(serv){return _c('div',{staticClass:"row at-row no-gutter bottomline"},[_c('div',{class:'col-1'}),_vm._v(" "),_c('div',{class:'col-15'},[(serv.IsPackage)?_c('div',[_c('at-badge',{attrs:{"value":"PAKKET"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(serv.Title))]),_vm._v(" "),_c('ul',[_vm._l((serv.Childs),function(serv2){return [_c('li',[_vm._v(" - "+_vm._s(serv2.Title))])]})],2)],1):_c('div',[_vm._v(_vm._s(serv.Title))]),_vm._v(" "),(serv.Detail.length > 1)?_c('span',[_c('small',[_vm._v(_vm._s(serv.Detail))])]):_vm._e()]),_vm._v(" "),_c('div',{class:'col-3'},[_c('div',{staticClass:"at-box-row bg-c-brand-light"},[_vm._v(" "+_vm._s(serv.IntDuration)+" min.")])]),_vm._v(" "),_c('div',{class:'col-3'},[_c('div',{staticClass:"at-box-row bg-c-brand-light"},[(!_vm.getPrice)?_c('span',[_vm._v("€ "+_vm._s(serv.Price))]):_vm._e()])]),_vm._v(" "),_c('div',{class:'col-2'},[_c('div',{staticClass:"at-box-row bg-c-brand-light"},[_c('at-button',{attrs:{"size":"smaller","icon":"icon-chevron-right","circle":""},on:{"click":function($event){_vm.addToCart (serv)}}})],1)])])})],2)])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qHjI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreClosed_vue__ = __webpack_require__("bLVN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130ea12c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreClosed_vue__ = __webpack_require__("SgUV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreClosed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130ea12c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreClosed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qPa6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleSalonCartDateItem_vue__ = __webpack_require__("LkKF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a11f6300_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleSalonCartDateItem_vue__ = __webpack_require__("Ipsd");
function injectStyle (ssrContext) {
  __webpack_require__("hj3X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleSalonCartDateItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a11f6300_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleSalonCartDateItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLXb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24 text-center"},[_c('h5',[_vm._v("Je afspraak is voorzien op :")]),_c('br'),_c('br'),_vm._v(" "),_c('h5',[_c('strong',[_vm._v(_vm._s(_vm.selTime.DateInfo))])]),_vm._v("\n                om "),_c('br'),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.selTime.TimeInfo))]),_c('br')]),_vm._v(" "),(this.selectedSinleStore != undefined)?_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24 text-center",staticStyle:{"text-align":"center","background-color":"#dedede","padding-top":"10px","border-radius":"10px","padding-bottom":"5px","margin-bottom":"10px"}},[_vm._v("\n              Je afspraak gaat door in salon"),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"width":"90%"}},[_c('h3',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(this.selectedSinleStore.UserName))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"90%"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"90%"}},[_c('h5',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.getSalonAdres(this.selectedSinleStore.Location)))])]),_vm._v(" "),_c('div',{staticClass:"row hidesmall"},[_vm._v(" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row hidesmall"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-24 text-center"},[_vm._v("\n                Jouw afspraak komt automatisch in onze agenda. "),_c('br'),_vm._v("\n                Je ontvangt ook nog een e-mail met de bevestiging."),_c('br'),_c('br'),_vm._v("\n                Indien je na 5 minuten nog geen mail hebt ontvangen, kijk ook eens in de folder van ongewenste e-mail."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                Bij twijfel contacteer ons telefonisch en geef datum en tijdstip door aub."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"product-btn"},[_c('a',{staticClass:"col-lg-12 col-md-12 col-sm-24",style:({ 'background-color': _vm.getColorApp, color: '#fff'}),on:{"click":_vm.resetAppoint}},[_c('i'),_vm._v("OK")])])]),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"height":"40px"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rQVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_products_ProductList_vue__ = __webpack_require__("divg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_categories_CategoryList_vue__ = __webpack_require__("j+8l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__ = __webpack_require__("G8sS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    'product-list': __WEBPACK_IMPORTED_MODULE_1__components_products_ProductList_vue__["a" /* default */],
    'category-list': __WEBPACK_IMPORTED_MODULE_2__components_categories_CategoryList_vue__["a" /* default */]
  },
  data: function data() {
    return {
      currentCat: {},
      storeCustomer: undefined,
      isSubCat: false,
      fullPage: false,
      isRoot: false,
      selectedSinleStore: undefined,
      kindLayout: 0,
      versionApp: ''
    };
  },
  created: function created() {
    document.title = "Reserveer online bij " + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName;
  },

  methods: {
    navigate: function navigate(item) {
      this.isSubCat = false;
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      this.$router.go(-1);
      this.isSubCat = false;
    }
  },
  computed: {
    navRoot: function navRoot() {
      if (this.selectedSinleStore != undefined) {
        return '/saloncategories';
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl;
      }
    },
    subcategories: function subcategories() {
      var cats = this.$store.getters.allCategories;
      var id = this.$route.params['id'];
      if (cats == undefined) {
        return [];
      }
      this.isSubCat = false;

      for (var i = 0; i < cats.length; i++) {
        var cat = cats[i];
        if (cat.CategoryID == id) {
          this.currentCat = cat;
          if (cat.SubCat == undefined) {
            return [];
          }

          this.isSubCat = true;
          return cat.SubCat;
        } else {
          if (cat.SubCat != undefined) {
            for (var s = 0; s < cat.SubCat.length; s++) {
              if (cat.SubCat[s].CategoryID == id) {
                this.currentCat = cat.SubCat[s];
                this.isSubCat = true;
                return cat.SubCat[s].SubCat;
              }
            }
          }
        }
      }

      this.isSubCat = false;
      return this.$store.getters.allCategories;
    },
    products: function products() {
      var cats = this.$store.getters.allCategories;
      var id = this.$route.params['id'];
      if (cats == undefined) {
        return [];
      }

      for (var i = 0; i < cats.length; i++) {
        var cat = cats[i];
        if (cat.CategoryID == id) {
          return cats[i].Services;
        } else {
          if (cat.SubCat != undefined) {
            for (var s = 0; s < cat.SubCat.length; s++) {
              if (cat.SubCat[s].CategoryID == id) {
                return cat.SubCat[s].Services;
              }
            }
          }
        }
      }

      return [];
    }
  },
  watch: {
    '$route': function $route(to, from) {}
  },
  mounted: function mounted() {
    this.isSubCat = false;
    this.storeCustomer = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeCustomer;
    this.selectedSinleStore = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore;
    this.kindLayout = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind;
    this.versionApp = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$version;
  }
});

/***/ }),

/***/ "riLc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['product', 'descr'],
  data: function data() {
    return {
      cart: this.$store.state.cart
    };
  },

  computed: {
    isAdding: function isAdding() {
      return this.cart.indexOf(this.product) < 0;
    },
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    }
  },
  methods: {
    addToCart: function addToCart() {

      if (this.hasPackageData()) {
        for (var i = 0; i < this.product.Childs.length; i++) {
          var a = this.product.Childs[i];
          a.PackageID = this.product.ArticleID;
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["o" /* ADD_TO_CART */], a);
        }
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["o" /* ADD_TO_CART */], this.product);
      }

      this.$router.push("/cart");
    },
    removeFromCart: function removeFromCart(id) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["p" /* REMOVE_FROM_CART */], id);
    },
    hasPackageData: function hasPackageData() {
      if (this.product.Childs == null) {
        return false;
      }
      if (this.product.Childs.length > 0) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),

/***/ "rkUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_calendar__ = __webpack_require__("sY/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_calendar_lib_v_calendar_min_css__ = __webpack_require__("xWv6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_calendar_lib_v_calendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_calendar_lib_v_calendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SingleSalonCartDateItem__ = __webpack_require__("qPa6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CartFreePlace__ = __webpack_require__("HJ+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      cart: this.$store.state.cart,
      isHideCal: false,
      weekChangeClicked: true,
      datWeek: '',
      openDays: [],
      freePaces: {},
      myDate: new Date(),
      isNoFreePlace: false,
      isShowNextFreeDate: false,
      blockNavToStartOfWeek: false,
      isWeekBack: false,
      dateNextStr: '',
      attrs: [{
        key: 'today',
        dates: new Date()
      }]
    };
  },

  components: {
    //vcalendar: VCalendar,
    dateItem: __WEBPACK_IMPORTED_MODULE_4__SingleSalonCartDateItem__["a" /* default */],
    cartFreePlace: __WEBPACK_IMPORTED_MODULE_5__CartFreePlace__["a" /* default */]
  },
  mounted: function mounted() {

    if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore === undefined) return;

    this.datWeek = new Date();
    this.myDate = this.datWeek;
    this.blockNavToStartOfWeek = true;
    this.loadWeekCal();
  },

  computed: {
    getColorApp: function getColorApp() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    },
    getUserSelectAllowed: function getUserSelectAllowed() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsHideUsers;
    }
  },
  methods: {
    selectDatEvt: function selectDatEvt(evt) {
      this.isWeekBack = false;
      this.isHideCal = false;
      var dtStr = evt.DateStr;
      this.myDate = new Date(evt.Year, evt.Month - 1, evt.Day, 23, 59, 0);
      this.datWeek = this.myDate;

      if (evt.StatusID == 1) {
        this.isNoFreePlace = true;
        return; //Geen plaats vrij.. geen uren gekend..
      }
      this.hideUnselectedDates(dtStr, false);
      this.loadFreePlaces();
    },
    hideUnselectedDates: function hideUnselectedDates(dtStr, flgReset) {

      for (var c = 0; c < this.openDays.length - 1; c++) {
        this.openDays[c].IsSelected = false;
        if (this.openDays[c].DateStr == dtStr) this.openDays[c].IsSelected = true;
      }
    },
    showCalendar: function showCalendar() {
      this.isHideCal = !this.isHideCal;
    },
    dayClicked: function dayClicked(day) {
      this.isHideCal = false;
      this.datWeek = day.date;
      this.myDate = day;
      this.blockNavToStartOfWeek = true;
      this.loadFreePlaces();
    },
    loadWeekCal: function loadWeekCal() {
      var _this = this;

      var searchRec = { Year: this.datWeek.getFullYear(), Month: this.datWeek.getMonth() + 1, Day: this.datWeek.getDate(), SalonID: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore.UserID };
      __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__["a" /* default */].post('Service/GetDaysWeekSingleSalon', searchRec).then(function (response) {
        _this.weekChangeClicked = false;
        _this.openDays = response.data;

        if (_this.openDays.length > 0) {
          _this.datWeek = new Date(_this.openDays[0].Year, _this.openDays[0].Month - 1, _this.openDays[0].Day, 23, 59, 0);
          _this.hideUnselectedDates(_this.openDays[0].DateStr, false);
        }

        _this.loadFreePlaces();
        _this.weekChangeClicked = true;
      }).catch(function (error) {
        console.log(error);
        _this.openDays = [];
        _this.weekChangeClicked = true;
      });
    },
    loadNextFreePlace: function loadNextFreePlace() {
      this.isShowNextFreeDate = true;
      this.hideUnselectedDates("", true);
      this.datWeek = new Date(this.openDays[this.openDays.length - 1].Year, this.openDays[this.openDays.length - 1].Month - 1, this.openDays[this.openDays.length - 1].Day, 23, 59, 0);
      this.loadWeekCal();
    },
    loadFreePlaces: function loadFreePlaces() {
      var _this2 = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["r" /* SPINNER_SHOW */]);
      var searchRec = { Year: this.datWeek.getFullYear(), Month: this.datWeek.getMonth() + 1, Day: this.datWeek.getDate(), BasketItems: this.cart,
        SearchNext: this.isShowNextFreeDate, BackButton: this.isWeekBack, UserID: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore.UserID };
      console.log(searchRec);

      this.isShowNextFreeDate = false;
      __WEBPACK_IMPORTED_MODULE_3__api_myhttpapi__["a" /* default */].post('Basket/GetFreePlacesSingleSalon', searchRec).then(function (response) {
        _this2.freePaces = response.data;
        _this2.isNoFreePlace = false;

        if (_this2.freePaces.Records.length <= 0) {
          _this2.isNoFreePlace = true;
        }
        if (_this2.freePaces.IsNextFreeApp) {
          _this2.dateNextStr = _this2.freePaces.DateStr;

          _this2.myDate = new Date(_this2.freePaces.Year, _this2.freePaces.Month - 1, _this2.freePaces.Day, 23, 59, 0);
          _this2.datWeek = _this2.myDate;

          _this2.datWeek.setDate(_this2.datWeek.getDate() + 1);
          _this2.weekRecord = _this2.freePaces.NextWeekDays;
          _this2.weekChangeClicked = true;
        }
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["s" /* SPINNER_HIDE */]);
      }).catch(function (error) {
        console.log(error);
        _this2.freePaces = [];
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["s" /* SPINNER_HIDE */]);
      });
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_v_calendar___default.a, {
  firstDayOfWeek: 2
});

/***/ }),

/***/ "tAl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      cart: this.$store.state.cart
    };
  },

  components: {},
  methods: {
    checkOut: function checkOut() {
      this.$router.push('/CustAppoint');
    },
    navigate: function navigate(item) {
      console.log("nav to :" + item);
      this.$router.push(item);
    }
  }
});

/***/ }),

/***/ "tH8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-18"},[(_vm.product.PackageID != undefined)?_c('div',{staticClass:"packageInfo"},[_vm._v("PAKKET")]):_vm._e(),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.product.Title))])]),_vm._v(" "),_c('div',{staticClass:"col-6",staticStyle:{"text-align":"right"}},[_c('div',[(!_vm.getPrice)?_c('span',[_vm._v("€"+_vm._s(_vm.product.Price)+" ")]):_vm._e(),(!_vm.hidedetails)?_c('cartdel-button',{attrs:{"product":_vm.product}}):_vm._e(),_vm._v("  ")],1)])]),_vm._v(" "),(_vm.isTrimSalon())?_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"8px"}},[_c('div',{staticClass:"col-10",staticStyle:{"margin-top":"15px"}},[_vm._v("Naam dier")]),_vm._v(" "),_c('div',{staticClass:"contact-message col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.Extra),expression:"product.Extra"}],attrs:{"name":"last_name","placeholder":"Vul naam in","type":"text"},domProps:{"value":(_vm.product.Extra)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "Extra", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(_vm.product.PriceAdvance !== 0)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-6",staticStyle:{"color":"#ff0000","text-align":"right"}},[_vm._v("€"+_vm._s(_vm.getPriceAdv ())+"  ")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-18"},[_c('strong',{staticStyle:{"color":"#ff0000"}},[_vm._v("Online voorschot gevraagd van ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tTQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppReservation_vue__ = __webpack_require__("vogq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd9bfd86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppReservation_vue__ = __webpack_require__("39Jg");
function injectStyle (ssrContext) {
  __webpack_require__("Lmdv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppReservation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd9bfd86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppReservation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cartMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return spinnerMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return manufacturerMutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");




var _productMutations, _cartMutations, _spinnerMutations, _manufacturerMutation;



var productMutations = (_productMutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ALL_PRODUCTS */], function (state) {
  // Called when fetching products
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* ALL_PRODUCTS_SUCCESS */], function (state, payload) {
  // Called when products have been fetched
  state.showLoader = false;
  // Updates state products
  state.products = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* PRODUCT_BY_ID */], function (state) {
  // Called when fetching products by ID
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* PRODUCT_BY_ID_SUCCESS */], function (state, payload) {
  // Called when product is fetched
  state.showLoader = false;
  // Updates state product
  state.product = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* ADD_PRODUCT */], function (state, payload) {
  // ...Same pattern
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* ADD_PRODUCT_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.products.push(payload);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* UPDATE_PRODUCT */], function (state, payload) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* UPDATE_PRODUCT_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.products = state.products.map(function (p) {
    if (p._id === payload._id) {
      payload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload, { manufacturer: state.manufacturers.filter(function (x) {
          return x._id === payload.manufacturer;
        })[0] });
      return payload;
    }
    return p;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* REMOVE_PRODUCT */], function (state, payload) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* REMOVE_PRODUCT_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  var index = state.products.findIndex(function (p) {
    return p._id === payload;
  });
  console.debug('index', index);
  state.products.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* ALL_CATEGORIES */], function (state) {
  // Called when fetching products
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* ALL_CATEGORIES_SUCCESS */], function (state, payload) {
  // Called when products have been fetched
  state.showLoader = false;
  // Updates state products
  state.categories = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* ALL_CALENDARS */], function (state) {
  // Called when fetching products
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* ALL_CALENDARS_SUCCESS */], function (state, payload) {
  // Called when products have been fetched
  state.showLoader = false;
  // Updates state products
  state.calendars = payload;
}), _productMutations);

var cartMutations = (_cartMutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* ADD_TO_CART */], function (state, payload) {
  var cloned = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
  state.cart.push(cloned);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* REMOVE_FROM_CART */], function (state, payload) {
  var index = state.cart.findIndex(function (p) {
    return p.ArticleID === payload.ArticleID;
  });
  state.cart.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* CLEAR_CART */], function (state) {
  state.cart = [];
}), _cartMutations);

var spinnerMutations = (_spinnerMutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_spinnerMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* SPINNER_SHOW */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_spinnerMutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* SPINNER_HIDE */], function (state) {
  state.showLoader = false;
}), _spinnerMutations);

var manufacturerMutations = (_manufacturerMutation = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_manufacturerMutation, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["t" /* ALL_MANUFACTURERS */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_manufacturerMutation, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["u" /* ALL_MANUFACTURERS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.manufacturers = payload;
}), _manufacturerMutation);

/***/ }),

/***/ "unrC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'paymentstatus',
   data: function data() {
      return {
         paymentStatInfo: '',
         statusPayment: 0,
         counter: 0,
         flgShowRetryPayment: false,
         payImgUrl: '/static/img/payments/Payment-wait-120.png',
         tmr: undefined,
         id: this.$route.params['id']
      };
   },

   components: {},
   mounted: function mounted() {
      this.statusPayment = 0;
      this.paymentStatInfo = "Betaling controleren";
      this.tmr = setInterval(this.checkStatusNow, 1000);
   },

   computed: {
      getColorApp: function getColorApp() {
         return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
      }
   },
   methods: {
      retryPament: function retryPament() {
         var _this = this;

         this.flgShowRetryPayment = false;

         var token = { Search: this.id };
         __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */].post('Basket/StartPayment', token).then(function (response) {
            var result = response.data;

            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* SPINNER_HIDE */]);
            _this.statusPayment = result.ResultCode;
            if (result.ResultCode == 200) {
               document.location = result.ErrorMsg;
            }
            if (result.ResultCode == 2) {
               _this.paymentStatInfo = "Betaling uitgevoerd!";
               _this.payImgUrl = '/static/img/payments/Payment-ok-120.png';
            }
         });
      },
      verifyPayment: function verifyPayment(keyPayment) {
         var _this2 = this;

         clearInterval(this.tmr);
         this.flgShowRetryPayment = false;
         var token = { Search: keyPayment };

         __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__["a" /* default */].post('Basket/VerifyPayment', token).then(function (response) {
            var result = response.data;
            _this2.statusPayment = result.ResultCode;
            if (result.ResultCode == 1) {
               _this2.paymentStatInfo = "Bezig...";
               _this2.payImgUrl = '/static/img/payments/Payment-wait-120.png';
               _this2.tmr = setInterval(_this2.checkStatusNow, 1000);
            }
            if (result.ResultCode == 2) {
               clearInterval(_this2.tmr);
               _this2.paymentStatInfo = "Betaling uitgevoerd!";
               _this2.payImgUrl = '/static/img/payments/Payment-ok-120.png';
            }
            if (result.ResultCode == 3) {
               _this2.paymentStatInfo = "Betaling mislukt";
               _this2.payImgUrl = '/static/img/payments/Payment-failed-120.png';
               clearInterval(_this2.tmr);
               _this2.flgShowRetryPayment = true;
            }
            if (result.ResultCode == 4) {
               _this2.paymentStatInfo = "Betaling  geannuleerd";
               _this2.payImgUrl = '/static/img/payments/Payment-failed-120.png';
               clearInterval(_this2.tmr);
               _this2.flgShowRetryPayment = true;
            }
            if (result.ResultCode == 5) {
               _this2.paymentStatInfo = "Betaling verlopen";
               _this2.payImgUrl = '/static/img/payments/Payment-failed-120.png';
               clearInterval(_this2.tmr);
               _this2.flgShowRetryPayment = true;
            }

            if (result.ResultCode == 999) {
               _this2.counter = 10;
               clearInterval(_this2.tmr);
               _this2.paymentStatInfo = "Fout bij ophalen";
               _this2.payImgUrl = '/static/img/payments/Payment-failed-120.png';
               _this2.flgShowRetryPayment = true;
            }
            console.log(_this2.statusPayment);
         });
      },
      checkStatusNow: function checkStatusNow() {

         this.counter += 1;
         this.paymentStatInfo = "wachten.. " + this.counter;
         if (this.counter % 2 == 1) this.verifyPayment(this.id);
         if (this.counter >= 15) {
            clearInterval(this.tmr);
            this.paymentStatInfo = "Fout bij ophalen";
            this.flgShowRetryPayment = true;
         }
      }
   }
});

/***/ }),

/***/ "vgS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartReservationDone_vue__ = __webpack_require__("R5IS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcf5238e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartReservationDone_vue__ = __webpack_require__("rLXb");
function injectStyle (ssrContext) {
  __webpack_require__("3Shw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartReservationDone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcf5238e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartReservationDone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vogq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_myhttpapi__ = __webpack_require__("G8sS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_dialog__ = __webpack_require__("7VfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_dialog_dist_vuejs_dialog_min_css__ = __webpack_require__("8cFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_dialog_dist_vuejs_dialog_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_dialog_dist_vuejs_dialog_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import toastr from 'toastr'

 // Import stylesheet










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuejs_dialog___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'appReservation',
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      cartItems: this.$store.state.cart,
      settingsData: {},
      colorApp: '',
      showBasket: true,
      isPaymentPage: false,
      isStoreClosed: false,
      webshopAddress: '',
      isInFrame: false,
      metaInfo: {
        title: ''
      }
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  created: function created() {

    document.title = "Reserveer online bij " + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName;
    this.isInFrame = !(self == top);

    this.webshopAddress = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.WebShopAddress;
    if (this.webshopAddress == null) this.webshopAddress = "";
    if (this.webshopAddress == undefined) this.webshopAddress = "";

    if (this.$route.name == "PaymentStatus") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus = true;
    }
    if (this.$route.name == "CustAppoint") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints = true;
    } else if (this.$route.name == "StoreAppoint") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints = true;
    }

    this.loadSettings(); //Niet verplaatsen!

    if (this.$route.name == "PaymentStatus") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus = true;
    } else if (this.$route.name == "CustAppoint") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints = true;
    } else if (this.$route.name == "StoreAppoint") {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints = true;
    } else {
      this.$router.push('/'); //Force to root on reload ?
    }

    if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus) this.isPaymentPage = true;
  },

  computed: {
    cartItemsCount: function cartItemsCount() {
      return this.cartItems.length;
    },
    showLoader: function showLoader() {
      return this.$store.state.showLoader;
    },
    getColorApp: function getColorApp() {
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings == undefined) return "";
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.ColorApp;
    },
    isCustAppoint: function isCustAppoint() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints;
    },
    navRoot: function navRoot() {
      //console.log ("base: " + Vue.$baseUrl);
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl;
    }
  },
  methods: {
    navigate: function navigate(item) {
      this.$router.push(item);
    },
    navigateBack: function navigateBack() {
      this.$router.go(-1);
    },
    loadSettings: function loadSettings() {

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$errorStartup = false;
      this.settingsData = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings;
      this.colorApp = this.settingsData.ColorApp;

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPosworld === false) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind = 1; //Salonworld
      //console.log ("layout:" +  Vue.$storeSettings.LayoutKind);

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind == 1) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl = '/list';else __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl = '/listws';

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind > 9) {
        if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.LayoutKind % 2 == 1) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl = '/list';
      }

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName == null) {
        console.log("no store found");
        this.settingsData = { StoreName: 'Geen shop gevonden', StoreAddress: 'op dit domain' };
        this.showBasket = false;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsStoreClosed) {
        this.isStoreClosed = true;
        this.$router.push({ path: '/storeclosed' });
        return;
      }

      if (this.$route.name == "PaymentStatus") {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus = true;
      }

      var canRoute = true;
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isCustAppoints) canRoute = false;
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$isPaymentStatus) canRoute = false;

      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsHasWelcomeMsg && canRoute) {
        if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.WelcomeMsg === undefined) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.WelcomeMsg = "";
        if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.WelcomeMsg === null) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.WelcomeMsg = "";

        var contentMsg = String(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.WelcomeMsg).split("\n").join("<br>");
        var message = {
          title: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.StoreName,
          body: contentMsg
        };
        var options = {
          html: true,
          okText: 'OK',
          verification: 'Ok'
        };

        this.$dialog.alert(message, options);
      }

      if (canRoute) {
        //console.log (this.$router.currentRoute.path)
        //this.$router.push({ path: Vue.$baseUrl })  //v6.2.x
        if (this.$router.currentRoute.path !== __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl) this.$router.push({ path: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl });
      }
    }
  }
});

/***/ }),

/***/ "x/X7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user', 'product'],
  data: function data() {
    return {};
  },

  computed: {
    getPicture: function getPicture() {
      var pic = "";
      if (this.user.IsHasPicture) {
        pic = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$urlCDN + "Images/" + this.user.PictureUrl;
      } else {
        pic = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$urlCDN + "Images/0/Usr/no-user120.jpg";
      }
      return pic;
    }
  },
  methods: {
    selectUser: function selectUser() {
      this.$emit('user-select-event', this.user);
    }
  }
});

/***/ }),

/***/ "xTHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-main-wrapper pt-20 pb-20 pt-sm-20 pb-sm-20"},[(_vm.cart.length > 0)?_c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"cart-table table-responsive"},[_c('table',{staticClass:"table table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.cart),function(product){return [_c('tr',[_c('td',{staticClass:"pro-title"},[_vm._v(_vm._s(product.Title))]),_vm._v(" "),_c('td',{staticClass:"pro-price"},[_c('span',[_vm._v("€"+_vm._s(product.Price))])])])]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")])]),_vm._v(" "),_c('div')]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"pro-title"},[_vm._v("Product")]),_vm._v(" "),_c('th',{staticClass:"pro-price"},[_vm._v("Price")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xWv6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xYcJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('category-list',{attrs:{"categories":_vm.subcategories,"products":_vm.products}})],1),_vm._v(" "),(_vm.isSubCat)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"}),_vm._v(" "),_c('router-link',{staticClass:"product-link",attrs:{"to":_vm.navRoot}},[_c('div',{staticClass:"product-btn",staticStyle:{"color":"#111111"}},[_c('a',[_c('i',{staticClass:"ion-arrow-left-c",staticStyle:{"color":"#111111"}}),_vm._v("Terug")])])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.selectedSinleStore !== undefined)?_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"product-link",attrs:{"to":"/saloncategories"}},[_c('div',{staticClass:"product-btn",staticStyle:{"color":"#111111"}},[_c('a',[_c('i',{staticStyle:{"color":"#111111"}}),_vm._v("Terug")])])])],1):_vm._e(),_vm._v(" "),(((_vm.kindLayout < 10) || (_vm.kindLayout == 20)))?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24",staticStyle:{"color":"#696969","text-align":"center","margin-top":"35px"}},[_c('a',{staticStyle:{"color":"#696969","font-size":"small"},attrs:{"target":"_blank","href":"https://www.posworld.be"}},[_vm._v("Powered by Posworld "),_c('small',[_vm._v(_vm._s(_vm.versionApp))])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xg+1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.selectedSinleStore != undefined)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v("Afspraak opmaken in salon "),_c('strong',[_vm._v(_vm._s(this.selectedSinleStore.UserName))]),_vm._v(" "),_c('br'),_vm._v(" "+_vm._s(_vm.getSalonAdres (this.selectedSinleStore.Location))),_c('br')])])]):_vm._e(),_vm._v(" "),(!_vm.isChild)?_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('h1',[_vm._v("Maak je keuze en kies een menu")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"shop-product-wrap grid row"},[_vm._l((_vm.categories),function(cat){return [_c('category-item',{attrs:{"category":cat}})]})],2),_vm._v(" "),_c('div',{staticClass:"shop-product-wrap grid row"},[(_vm.isChild)?[_c('div',{staticClass:"row col-24",staticStyle:{"margin-bottom":"10px"}},[_c('h2',[_vm._v(_vm._s(_vm.getCatName ())+" menu")])])]:_vm._e(),_vm._v(" "),_vm._l((_vm.products),function(product){return [_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-24"},[_c('product-item-lst-view',{attrs:{"product":product}})],1)]}),_vm._v(" "),(_vm.products.length > 0)?[(_vm.isShowPrices())?_c('div',{staticStyle:{"margin-bottom":"20px","margin-top":"15px"}},[_vm._v("Ter info: De prijzen kunnen eventueel gewijzigd worden op basis van soort, de duur en de complexiteit van de dienst. Probeer dus zo correct mogelijk de juiste dienst uit te kiezen.")]):_vm._e()]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yFQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v("  Volgende tijden zijn beschikbaar op "),_c('strong',[_vm._v(_vm._s(_vm.record.DateInfo))]),_vm._v("  "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showfreeplaces),expression:"!showfreeplaces"}],staticClass:"ion-arrow-down-c",on:{"click":function($event){_vm.showfreeplaces = !_vm.showfreeplaces}}})]),_vm._v(" "),_c('div',{staticClass:"row titleMenuBasket"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row col-24"},[_vm._l((_vm.getFreeTimes),function(rec){return [_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showfreeplaces),expression:"showfreeplaces"}],staticClass:"col-lg-4 col-md-4 col-sm-3 col-xs-6"},[_c('div',{staticClass:"time-btn",style:(_vm.buttonStyles),on:{"click":function($event){_vm.freePlaceClicked (rec)}}},[_c('a',{style:(_vm.buttonStyles)},[_vm._v(_vm._s(rec.TimeInfo))])])])]})],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showfreeplaces),expression:"!showfreeplaces"}],staticClass:"col-12"},[(_vm.selectedTime !== undefined)?_c('div',[_vm._v("Gekozen afspraak : "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.record.DateInfo))]),_vm._v(" om  "),_c('strong',{staticStyle:{"font-size":"100%"}},[_vm._v(_vm._s(this.selectedTime.TimeInfo))])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showfreeplaces),expression:"!showfreeplaces"}],staticClass:"col-12 top-bar-right"},[_c('div',{staticClass:"product-btn",class:{ 'product-btn__color': this.canContinue }},[_c('a',{style:({ 'background-color': _vm.getColorApp, color: '#ffffff'}),on:{"click":function($event){return _vm.confirmReservation();}}},[_c('i',{staticClass:"ion-bag"}),_vm._v("Volgende")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yFTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'startup',
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  updated: function updated() {},
  mounted: function mounted() {

    if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$errorStartup) {
      this.$router.push({ path: 'Error' });
      return;
    }

    this.$store.dispatch('allCategories');
    this.$router.push({ path: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$baseUrl });
  }
});

/***/ }),

/***/ "yI0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(this.selectedSinleStore != undefined)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v("Afspraak opmaken in salon "),_c('strong',[_vm._v(_vm._s(this.selectedSinleStore.UserName))]),_vm._v(" "),_c('br'),_vm._v(" "+_vm._s(_vm.getSalonAdres (this.selectedSinleStore.Location)))])])]):_vm._e(),_vm._v(" "),(this.storeCustomer != undefined)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v("Afspraak opmaken voor "),_c('strong',[_vm._v(_vm._s(this.storeCustomer.FirstName)+"  "+_vm._s(this.storeCustomer.LastName))])])])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[(_vm.cart.length > 0)?_c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[(_vm.getHasStoreMsg)?_c('div',{staticClass:"col-lg-12 col-sm-24 col-md-24",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"row",staticStyle:{"background-color":"#edefef","border-radius":"7px","padding":"15px","margin":"5px","word-wrap":"break-word"}},[_c('span',{staticStyle:{"word-wrap":"break-word","width":"90%"},domProps:{"innerHTML":_vm._s(_vm.getStoreMsg)}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-16 col-xs-24"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row titleMenuBasket",style:({ 'background-color': _vm.getColorApp})},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v("  ")]),_vm._v(" "),_vm._l((_vm.cart),function(product){return [_c('cart-item',{attrs:{"product":product}}),_vm._v(" "),(!_vm.getUserSelectAllowed)?_c('cart-item-user-lst',{attrs:{"product":product},on:{"user-select-forprod":_vm.onselectUserList}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"height":"10px"}},[_vm._v(" ")])]}),_vm._v(" "),_c('div',{attrs:{"id":"overlayUsers"}},[_c('div',{staticStyle:{"margin":"20px","padding":"20px","background-color":"#ffffff","border-radius":"15px","border-color":"#111111"}},[_c('h3',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("Kies behandelaar voor")]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"10px"}},[_vm._v(_vm._s(this.getProductName))]),_vm._v(" "),_vm._l((_vm.selectedUsers),function(usr){return [_c('cart-item-user',{attrs:{"user":usr,"product":_vm.selectedProd},on:{"user-select-event":_vm.selectUserEvt}})]})],2)]),_vm._v(" "),(_vm.getTotalsAdvance () > 0)?_c('div',{staticClass:"row",staticStyle:{"background-color":"#999999","height":"30px","line-height":"30px","border-radius":"5px","padding-left":"5px"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-6",staticStyle:{"color":"#ffffff","text-align":"right"}},[_vm._v("€"+_vm._s(_vm.getTotalsAdvancePrice ())+"  ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-13"},[_c('router-link',{staticClass:"product-link",attrs:{"to":_vm.navRoot}},[_c('div',{staticClass:"row product-btn"},[_c('a',{staticStyle:{"color":"#111111"}},[_c('i',{staticClass:"ion-plus",staticStyle:{"color":"#111111"}}),_vm._v("Extra behandeling")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-1"}),_vm._v(" "),_c('div',{staticClass:"col-10",staticStyle:{"float":"right"}},[_c('div',{staticClass:"row product-btn"},[_c('a',{style:({ 'background-color': _vm.getColorApp, color: '#ffffff'}),on:{"click":function($event){return _vm.checkOut();}}},[_c('i',{staticClass:"ion-bag"}),_vm._v("Volgende")])])])])],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('router-link',{staticClass:"product-link",attrs:{"to":_vm.navRoot}},[_c('div',{staticClass:"row product-btn"},[_c('a',{staticStyle:{"color":"#111111"}},[_c('i',{staticClass:"ion-arrow-left-c",staticStyle:{"color":"#111111"}}),_vm._v("Terug")])])])],1)]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row col-24"},[_vm._v(" ")])]),_vm._v(" "),_c('div')]):_c('div',{staticClass:"title"},[_c('div',{staticClass:"container"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('router-link',{staticClass:"product-link",attrs:{"to":_vm.navRoot}},[_c('div',{staticClass:"product-btn product-btn__color"},[_c('a',{style:({ 'background-color': _vm.getColorApp, color: '#ffffff'})},[_c('i',{staticClass:"ion-arrow-left-c"}),_vm._v("Terug")])])])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-24"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._v("  "),_c('h5',[_vm._v("Jouw behandelingen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-18"},[_c('strong',{staticStyle:{"color":"#ffffff"}},[_vm._v("Totaal voorschot gevraagd van ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h5',[_c('i',{staticClass:"fa fa-superpowers"}),_vm._v(" Winkelmand is leeg")]),_c('br')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z+Mq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startup_vue__ = __webpack_require__("yFTj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b5da33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Startup_vue__ = __webpack_require__("fPMW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b5da33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Startup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z257":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CategoryItem_vue__ = __webpack_require__("2NE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_ProductItem_vue__ = __webpack_require__("IzEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__products_ProductItemLstView_vue__ = __webpack_require__("9SMP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'category-list',
  props: ['categories', 'products'],
  created: function created() {},
  data: function data() {
    return {
      product: {},
      cat: {},
      isChild: false,
      catName: '',
      showPrices: false,
      selectedSinleStore: undefined
    };
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsStoreClosed) {
      this.$router.push({ path: '/storeclosed' });
      return;
    }
    this.selectedSinleStore = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$selectedStore;
  },

  computed: {},
  methods: {
    navBack: function navBack() {
      this.$router.go(-1);
    },
    getCatName: function getCatName() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$currCatName;
    },
    isShowPrices: function isShowPrices() {
      return !__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsHidePrice;
    },
    getSalonAdres: function getSalonAdres(locationname) {
      var arr = locationname.split(",");
      if (arr.length > 1) return arr[1];
      return locationname;
    }
  },
  components: {
    'category-item': __WEBPACK_IMPORTED_MODULE_1__CategoryItem_vue__["a" /* default */],
    'product-item': __WEBPACK_IMPORTED_MODULE_2__products_ProductItem_vue__["a" /* default */],
    'product-item-lst-view': __WEBPACK_IMPORTED_MODULE_3__products_ProductItemLstView_vue__["a" /* default */]
  },
  watch: {
    '$route': function $route(to, from) {
      var id = this.$route.params['id'];
      this.isChild = false;
      if (id != undefined) {
        this.isChild = true;
      }
    }
  }

});

/***/ }),

/***/ "zE6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartDelButton__ = __webpack_require__("2VJK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['product', 'hidedetails'],
  data: function data() {
    return {
      cart: this.$store.state.cart
    };
  },

  components: {
    cartdelButton: __WEBPACK_IMPORTED_MODULE_1__CartDelButton__["a" /* default */]
  },
  methods: {
    getPriceAdv: function getPriceAdv() {
      return this.product.PriceAdvance.toFixed(2);
    },
    isTrimSalon: function isTrimSalon() {
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.KindStore === undefined) return false;
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.KindStore === 15) return true;
      return false;
    }
  },
  computed: {
    getPrice: function getPrice() {
      if (this.product.Price == "0") {
        return true;
      }
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$storeSettings.IsHidePrices;
    }
  }
});

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.a5bc8102097dba7be040.js